/**
 * Funnel Strategies Configuration - COMPLETE DICTIONARY
 * SOURCE OF TRUTH for all strategies, variants, and assets to generate.
 * Steps 3-6 will read from this configuration to know exactly what to generate.
 * 
 * 14 Main Categories with 40+ variants covering ALL market strategies
 */

export const FUNNEL_STRATEGIES = [
  // ============================================
  // 🔴 LANZAMIENTO EN DIRECTO
  // ============================================
  {
    id: "lanzamiento",
    label: "Lanzamiento",
    icon: "🔴",
    color: "#EF4444",
    description: "Webinars y eventos en vivo con carrito limitado y urgencia real.",
    separar_fases_creativos: true,
    variants: [
      {
        id: "1-directo",
        label: "1 Solo Directo",
        description: "Webinar único con apertura de carrito configurable. Ideal para lanzamientos rápidos.",
        defaultAssets: {
          cartHours: 24,
          landings: ["Página de Registro", "Página Puente (Únete a WA)", "Página Gracias (Pixel Lead)", "Sala del Directo / Replay", "Página de Ventas", "Gracias por Compra (Pixel Purchase)"],
          emails: 8,
          whatsapp: 6,
          adCopies: 4,
          adCreatives: 11
        },
        emails: [
          { 
            id: 'email_bienvenida', 
            nombre: 'Email Bienvenida', 
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar registro y generar expectativa del directo',
            incluir: 'Fecha y hora del directo, qué van a aprender, link de acceso',
            excluir: 'Precios, ofertas, ventas',
            max_words: 200
          },
          { 
            id: 'email_recordatorio_d1', 
            nombre: 'Recordatorio D-1', 
            momento: '1 día antes del Directo',
            objetivo: 'Recordar el evento y aumentar asistencia',
            incluir: 'Beneficios de asistir en vivo, hora exacta, añadir a calendario',
            excluir: 'Precios, ventas, contenido largo',
            max_words: 150
          },
          { 
            id: 'email_dia_directo', 
            nombre: 'Día del Directo', 
            momento: 'Mañana del Directo',
            objetivo: 'Asegurar máxima asistencia',
            incluir: 'Link de acceso, hora, incentivo por asistir en vivo',
            excluir: 'Ventas, precios, texto largo',
            max_words: 120
          },
          { 
            id: 'email_en_directo', 
            nombre: 'Estamos en Directo', 
            momento: 'Al empezar el Directo',
            objetivo: 'Llevar gente al directo AHORA',
            incluir: 'Link directo, urgencia de entrar ya, emoji llamativo',
            excluir: 'Todo lo que no sea link y urgencia',
            max_words: 80
          },
          { 
            id: 'email_replay', 
            nombre: 'Replay Disponible', 
            momento: '+2h después del Directo',
            objetivo: 'Compartir replay y preparar para la venta',
            incluir: 'Link al replay, tiempo limitado disponible, resumen del directo',
            excluir: 'Precio directo, venta agresiva',
            max_words: 180
          },
          { 
            id: 'email_apertura_carrito', 
            nombre: 'Apertura de Carrito', 
            momento: 'Post-directo — apertura oficial',
            objetivo: 'Anunciar que el carrito está abierto con oferta',
            incluir: 'Precio, bonus, deadline, link de compra, garantía',
            excluir: 'Contenido educativo, historia larga',
            max_words: 250
          },
          { 
            id: 'email_urgencia', 
            nombre: 'Urgencia — Cierra Pronto', 
            momento: 'Últimas 12h de carrito',
            objetivo: 'Crear urgencia real de cierre',
            incluir: 'Horas que quedan, lo que pierden, link directo',
            excluir: 'Explicaciones largas, contenido nuevo',
            max_words: 150
          },
          { 
            id: 'email_cierre', 
            nombre: 'Último Aviso — Cierre', 
            momento: 'Últimas 2h de carrito',
            objetivo: 'Último empujón para decisión',
            incluir: 'Urgencia máxima, countdown, link directo, qué pierden',
            excluir: 'Todo lo que no sea urgencia',
            max_words: 120
          }
        ],
        whatsapp: [
          {
            id: 'wa_confirmacion',
            nombre: 'WA Confirmación',
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar inscripción y dar la bienvenida',
            incluir: 'Nombre del evento, fecha y hora, link de grupo WA',
            excluir: 'Precios, ofertas, urgencia',
            max_chars: 280
          },
          {
            id: 'wa_recordatorio',
            nombre: 'WA Recordatorio D-1',
            momento: '1 día antes del Directo',
            objetivo: 'Recordar y generar expectativa',
            incluir: 'Fecha, hora, qué van a aprender, link de acceso',
            excluir: 'Precios, ventas',
            max_chars: 250
          },
          {
            id: 'wa_3h_antes',
            nombre: 'WA 3h Antes',
            momento: '3 horas antes del Directo',
            objetivo: 'Recordatorio urgente',
            incluir: 'Hora exacta, link directo, crear expectativa',
            excluir: 'Texto largo, precios',
            max_chars: 180
          },
          {
            id: 'wa_en_directo',
            nombre: 'WA Estamos en Directo',
            momento: 'Al empezar el Directo',
            objetivo: 'Enviar link de acceso inmediato',
            incluir: 'Link clickeable, mensaje corto y urgente',
            excluir: 'Texto largo, explicaciones',
            max_chars: 150
          },
          {
            id: 'wa_oferta',
            nombre: 'WA Oferta Abierta',
            momento: 'Tras el Directo — apertura carrito',
            objetivo: 'Anunciar oferta con urgencia',
            incluir: 'Precio, bonus principal, deadline, link de compra',
            excluir: 'Vaguedades, texto sin CTA',
            max_chars: 320
          },
          {
            id: 'wa_cierre',
            nombre: 'WA Último Aviso',
            momento: 'Últimas 2h de carrito',
            objetivo: 'Último mensaje de cierre',
            incluir: 'Urgencia máxima, link directo, qué pasa si no actúan',
            excluir: 'Todo lo que no sea urgencia y link',
            max_chars: 200
          }
        ],
        adCreatives: [
          // FASE CAPTACIÓN (5)
          { id: 'cap_video_intriga', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Intriga — Problema/Promesa' },
          { id: 'cap_imagen_headline', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Headline Principal' },
          { id: 'cap_story_cuenta_atras', tipo: 'captacion', formato: 'story', nombre: 'Story — Cuenta Atrás Directo' },
          { id: 'cap_reel_problema', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Problema del Avatar' },
          { id: 'cap_testimonio_video', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — Resultado' },
          // FASE VENTA (6)
          { id: 'ven_video_oferta', tipo: 'venta', formato: 'video', nombre: 'Vídeo Oferta — Qué incluye + Precio' },
          { id: 'ven_imagen_urgencia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Urgencia — Cierra en X horas' },
          { id: 'ven_story_cierre', tipo: 'venta', formato: 'story', nombre: 'Story — Últimas horas' },
          { id: 'ven_retargeting_objecion', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción resuelta' },
          { id: 'ven_testimonio_resultado', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Testimonio — Resultado concreto' },
          { id: 'ven_imagen_garantia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Garantía + Bonus' },
        ]
      },
      {
        id: "2-directos",
        label: "2 Directos",
        description: "Masterclass de apertura + Directo de cierre. Más tiempo de nurturing.",
        defaultAssets: {
          cartHours: 48,
          landings: ["Página de Registro", "Página Puente (Únete a WA)", "Página Gracias (Pixel Lead)", "Sala Directo 1", "Sala Directo 2 / Ventas", "Gracias por Compra"],
          emails: 15,
          whatsapp: 8,
          adCopies: 4,
          adCreatives: 14
        },
        emails: [
          { 
            id: 'email_bienvenida', 
            nombre: 'Email Bienvenida', 
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar registro y generar expectativa de la serie',
            incluir: 'Fechas de los 2 directos, qué van a aprender, link de acceso',
            excluir: 'Precios, ofertas, ventas',
            max_words: 200
          },
          { 
            id: 'email_recordatorio_d3', 
            nombre: 'Recordatorio D-3', 
            momento: '3 días antes Directo 1',
            objetivo: 'Mantener enganche y anticipación',
            incluir: 'Valor del contenido, fecha del Directo 1, añadir a calendario',
            excluir: 'Precios, ventas',
            max_words: 180
          },
          { 
            id: 'email_recordatorio_d1', 
            nombre: 'Recordatorio D-1', 
            momento: '1 día antes Directo 1',
            objetivo: 'Asegurar asistencia al primer directo',
            incluir: 'Beneficios de asistir en vivo, hora exacta, incentivo',
            excluir: 'Ventas, contenido largo',
            max_words: 150
          },
          { 
            id: 'email_dia_directo1', 
            nombre: 'Día del Directo 1', 
            momento: 'Mañana del Directo 1',
            objetivo: 'Máxima asistencia al Directo 1',
            incluir: 'Link de acceso, hora, qué se va a revelar',
            excluir: 'Ventas, precios',
            max_words: 120
          },
          { 
            id: 'email_en_directo1', 
            nombre: 'Estamos en Directo 1', 
            momento: 'Al empezar el Directo 1',
            objetivo: 'Llevar gente al directo AHORA',
            incluir: 'Link directo, urgencia de entrar ya',
            excluir: 'Todo lo que no sea link y urgencia',
            max_words: 80
          },
          { 
            id: 'email_post_directo1', 
            nombre: 'Post Directo 1', 
            momento: 'Noche del Directo 1',
            objetivo: 'Recap y anticipar Directo 2',
            incluir: 'Resumen de lo aprendido, link replay, fecha Directo 2',
            excluir: 'Ventas directas',
            max_words: 200
          },
          { 
            id: 'email_recordatorio_d2', 
            nombre: 'Recordatorio Directo 2', 
            momento: '1 día antes Directo 2',
            objetivo: 'Asegurar asistencia al segundo directo',
            incluir: 'Promesa del Directo 2, hora exacta, por qué no perdérselo',
            excluir: 'Precio explícito',
            max_words: 150
          },
          { 
            id: 'email_dia_directo2', 
            nombre: 'Día del Directo 2', 
            momento: 'Mañana del Directo 2',
            objetivo: 'Máxima asistencia al Directo 2 (el de venta)',
            incluir: 'Link de acceso, hora, qué se va a revelar, anticipar sorpresa',
            excluir: 'Precio antes del directo',
            max_words: 120
          },
          { 
            id: 'email_en_directo2', 
            nombre: 'Estamos en Directo 2', 
            momento: 'Al empezar el Directo 2',
            objetivo: 'Llevar gente al directo de ventas',
            incluir: 'Link directo, urgencia, será la revelación',
            excluir: 'Todo lo que no sea link',
            max_words: 80
          },
          { 
            id: 'email_apertura_carrito', 
            nombre: 'Apertura de Carrito', 
            momento: 'Tras el Directo 2',
            objetivo: 'Anunciar oficialmente la oferta',
            incluir: 'Precio, bonus, deadline claro, link de compra, garantía',
            excluir: 'Contenido educativo nuevo',
            max_words: 280
          },
          { 
            id: 'email_replay_directo2', 
            nombre: 'Replay Directo 2', 
            momento: '+24h del Directo 2',
            objetivo: 'Dar replay y recordar oferta',
            incluir: 'Link al replay, tiempo disponible, resumen oferta',
            excluir: 'Repetir todo el contenido',
            max_words: 180
          },
          { 
            id: 'email_objecion_precio', 
            nombre: 'Objeción Precio', 
            momento: '+48h apertura carrito',
            objetivo: 'Resolver objeción de precio',
            incluir: 'ROI, comparativa con alternativas, facilidades de pago',
            excluir: 'Presión excesiva',
            max_words: 250
          },
          { 
            id: 'email_testimonio_prueba', 
            nombre: 'Testimonio + Prueba Social', 
            momento: '+72h apertura carrito',
            objetivo: 'Mostrar resultados de otros',
            incluir: 'Testimonios específicos, resultados concretos, link compra',
            excluir: 'Historias genéricas',
            max_words: 220
          },
          { 
            id: 'email_urgencia_48h', 
            nombre: 'Urgencia 48h', 
            momento: 'Penúltimo día carrito',
            objetivo: 'Crear urgencia real',
            incluir: 'Horas que quedan, bonus que desaparecen, link directo',
            excluir: 'Contenido nuevo',
            max_words: 150
          },
          { 
            id: 'email_cierre_carrito', 
            nombre: 'Cierre de Carrito', 
            momento: 'Último día — últimas horas',
            objetivo: 'Último empujón para decisión',
            incluir: 'Urgencia máxima, countdown, link directo, qué pierden',
            excluir: 'Explicaciones largas',
            max_words: 120
          }
        ],
        whatsapp: [
          {
            id: 'wa_confirmacion',
            nombre: 'WA Confirmación',
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar inscripción y generar expectativa',
            incluir: 'Nombre del evento, fecha del Directo 1, link de acceso al grupo',
            excluir: 'Precios, ofertas, urgencia',
            max_chars: 300
          },
          {
            id: 'wa_recordatorio_d1',
            nombre: 'WA Recordatorio D-1',
            momento: '1 día antes del Directo 1',
            objetivo: 'Recordar el evento y aumentar expectativa',
            incluir: 'Fecha y hora del directo, link de acceso, qué van a aprender',
            excluir: 'Precios, ventas',
            max_chars: 250
          },
          {
            id: 'wa_3h_antes',
            nombre: 'WA 3h Antes',
            momento: '3 horas antes del Directo 1',
            objetivo: 'Recordatorio urgente con link directo',
            incluir: 'Link directo al directo, hora exacta, crear urgencia de asistencia',
            excluir: 'Mucho texto, precios',
            max_chars: 200
          },
          {
            id: 'wa_link_directo',
            nombre: 'WA Link del Directo',
            momento: 'Al empezar el Directo 1',
            objetivo: 'Enviar link de acceso inmediato',
            incluir: 'Link clickeable, mensaje muy corto y directo',
            excluir: 'Texto largo, explicaciones',
            max_chars: 150
          },
          {
            id: 'wa_replay',
            nombre: 'WA Replay',
            momento: '+2h después del Directo 1',
            objetivo: 'Compartir replay para quien no pudo asistir',
            incluir: 'Link al replay, tiempo disponible del replay, resumen de lo que se vio',
            excluir: 'Ventas directas, precio',
            max_chars: 300
          },
          {
            id: 'wa_oferta_especial',
            nombre: 'WA Oferta Especial',
            momento: 'Tras el Directo 2 — apertura de carrito',
            objetivo: 'Anunciar apertura de carrito con urgencia',
            incluir: 'Precio, bonus, deadline claro, link de compra',
            excluir: 'Vaguedades, texto sin CTA claro',
            max_chars: 350
          },
          {
            id: 'wa_urgencia',
            nombre: 'WA Urgencia',
            momento: '24h antes del cierre de carrito',
            objetivo: 'Crear urgencia real de cierre',
            incluir: 'Horas que quedan, lo que pierden si no actúan, link directo',
            excluir: 'Explicaciones largas',
            max_chars: 250
          },
          {
            id: 'wa_ultimo_aviso',
            nombre: 'WA Último Aviso',
            momento: '2h antes del cierre definitivo',
            objetivo: 'Último mensaje de cierre de carrito',
            incluir: 'Urgencia máxima, link directo, qué pasa cuando cierre',
            excluir: 'Todo lo que no sea urgencia y link',
            max_chars: 200
          }
        ],
        adCreatives: [
          // FASE CAPTACIÓN (6)
          { id: 'cap_video_intriga', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Intriga — Problema/Promesa' },
          { id: 'cap_imagen_headline', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Headline Principal' },
          { id: 'cap_story_directo1', tipo: 'captacion', formato: 'story', nombre: 'Story — Directo 1 Cuenta Atrás' },
          { id: 'cap_story_directo2', tipo: 'captacion', formato: 'story', nombre: 'Story — Directo 2 Cuenta Atrás' },
          { id: 'cap_reel_problema', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Problema del Avatar' },
          { id: 'cap_testimonio_video', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — Resultado' },
          // FASE VENTA (8)
          { id: 'ven_video_oferta', tipo: 'venta', formato: 'video', nombre: 'Vídeo Oferta — Qué incluye + Precio' },
          { id: 'ven_imagen_urgencia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Urgencia — Cierra en X horas' },
          { id: 'ven_story_cierre', tipo: 'venta', formato: 'story', nombre: 'Story — Últimas horas' },
          { id: 'ven_retargeting_objecion1', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción precio' },
          { id: 'ven_retargeting_objecion2', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción tiempo' },
          { id: 'ven_testimonio_resultado', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Testimonio — Resultado concreto' },
          { id: 'ven_imagen_garantia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Garantía + Bonus' },
          { id: 'ven_video_urgencia_final', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre final 2h' },
        ]
      },
      {
        id: "3-directos",
        label: "3 Directos",
        description: "Serie de formación: Contenido → Pitch → Cierre. Máxima conexión con la audiencia.",
        defaultAssets: {
          cartHours: 72,
          landings: ["Página de Registro", "Página Puente (Únete a WA)", "Página Gracias (Pixel Lead)", "Sala Live 1", "Sala Live 2", "Sala Live 3 / Ventas", "Gracias por Compra"],
          emails: 15,
          whatsapp: 10,
          adCopies: 5,
          adCreatives: 18
        },
        emails: [
          { 
            id: 'email_bienvenida', 
            nombre: 'Email Bienvenida', 
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar registro y presentar la serie de 3 directos',
            incluir: 'Fechas de los 3 directos, qué aprenderán en cada uno, link de acceso',
            excluir: 'Precios, ofertas, ventas',
            max_words: 220
          },
          { 
            id: 'email_recordatorio_d1_d3', 
            nombre: 'Recordatorio D-3 Directo 1', 
            momento: '3 días antes Directo 1',
            objetivo: 'Mantener enganche con la serie',
            incluir: 'Valor del Directo 1, fecha, añadir a calendario',
            excluir: 'Ventas, precios',
            max_words: 150
          },
          { 
            id: 'email_dia_directo1', 
            nombre: 'Día del Directo 1', 
            momento: 'Mañana del Directo 1',
            objetivo: 'Asegurar asistencia al primer directo',
            incluir: 'Link de acceso, hora, qué se va a revelar',
            excluir: 'Ventas, contenido largo',
            max_words: 120
          },
          { 
            id: 'email_en_directo1', 
            nombre: 'Estamos en Directo 1', 
            momento: 'Al empezar el Directo 1',
            objetivo: 'Llevar gente al directo AHORA',
            incluir: 'Link directo, urgencia de entrar ya',
            excluir: 'Todo lo que no sea link',
            max_words: 80
          },
          { 
            id: 'email_post_directo1', 
            nombre: 'Post Directo 1 + Anticipo D2', 
            momento: 'Noche del Directo 1',
            objetivo: 'Recap D1 y anticipar D2',
            incluir: 'Resumen de lo aprendido, link replay, fecha Directo 2',
            excluir: 'Ventas directas',
            max_words: 180
          },
          { 
            id: 'email_dia_directo2', 
            nombre: 'Día del Directo 2', 
            momento: 'Mañana del Directo 2',
            objetivo: 'Asegurar asistencia al segundo directo',
            incluir: 'Link de acceso, hora, promesa de valor único',
            excluir: 'Ventas directas',
            max_words: 120
          },
          { 
            id: 'email_en_directo2', 
            nombre: 'Estamos en Directo 2', 
            momento: 'Al empezar el Directo 2',
            objetivo: 'Llevar gente al directo 2',
            incluir: 'Link directo, urgencia',
            excluir: 'Todo lo que no sea link',
            max_words: 80
          },
          { 
            id: 'email_post_directo2', 
            nombre: 'Post Directo 2 + Anticipo D3', 
            momento: 'Noche del Directo 2',
            objetivo: 'Recap D2 y anticipar el cierre en D3',
            incluir: 'Resumen, replay, anticipación de oferta en D3',
            excluir: 'Revelar precio',
            max_words: 180
          },
          { 
            id: 'email_dia_directo3', 
            nombre: 'Día del Directo 3', 
            momento: 'Mañana del Directo 3',
            objetivo: 'Máxima asistencia al directo de cierre/venta',
            incluir: 'Link de acceso, hora, anticipar sorpresa/oferta',
            excluir: 'Revelar precio antes',
            max_words: 120
          },
          { 
            id: 'email_en_directo3', 
            nombre: 'Estamos en Directo 3', 
            momento: 'Al empezar el Directo 3',
            objetivo: 'Llevar gente al directo de cierre',
            incluir: 'Link directo, urgencia, será la revelación',
            excluir: 'Todo lo que no sea link',
            max_words: 80
          },
          { 
            id: 'email_apertura_carrito', 
            nombre: 'Apertura de Carrito', 
            momento: 'Post Directo 3',
            objetivo: 'Anunciar oficialmente la oferta',
            incluir: 'Precio, bonus, deadline, link de compra, garantía',
            excluir: 'Contenido educativo nuevo',
            max_words: 280
          },
          { 
            id: 'email_replay_d3', 
            nombre: 'Replay Directo 3', 
            momento: '+24h del Directo 3',
            objetivo: 'Dar replay del cierre y recordar oferta',
            incluir: 'Link al replay, resumen oferta, deadline',
            excluir: 'Repetir todo el contenido',
            max_words: 180
          },
          { 
            id: 'email_objecion', 
            nombre: 'Objeción Principal', 
            momento: '+48h apertura carrito',
            objetivo: 'Resolver la objeción más común',
            incluir: 'Objeción específica, respuesta clara, testimonios',
            excluir: 'Presión excesiva',
            max_words: 220
          },
          { 
            id: 'email_urgencia', 
            nombre: 'Urgencia 24h', 
            momento: 'Penúltimo día carrito',
            objetivo: 'Crear urgencia real',
            incluir: 'Horas que quedan, bonus que desaparecen, link directo',
            excluir: 'Contenido nuevo',
            max_words: 150
          },
          { 
            id: 'email_cierre', 
            nombre: 'Cierre de Carrito', 
            momento: 'Último día — últimas horas',
            objetivo: 'Último empujón para decisión',
            incluir: 'Urgencia máxima, countdown, link directo, qué pierden',
            excluir: 'Explicaciones largas',
            max_words: 120
          }
        ],
        whatsapp: [
          {
            id: 'wa_confirmacion',
            nombre: 'WA Confirmación',
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar inscripción a la serie de 3 directos',
            incluir: 'Fechas de los 3 directos, link de grupo',
            excluir: 'Precios, ofertas',
            max_chars: 300
          },
          {
            id: 'wa_recordatorio_d1',
            nombre: 'WA Recordatorio Directo 1',
            momento: '1 día antes Directo 1',
            objetivo: 'Recordar primer directo',
            incluir: 'Fecha, hora, qué aprenderán',
            excluir: 'Precios, ventas',
            max_chars: 220
          },
          {
            id: 'wa_link_d1',
            nombre: 'WA Link Directo 1',
            momento: 'Al empezar Directo 1',
            objetivo: 'Enviar link de acceso',
            incluir: 'Link directo, mensaje corto',
            excluir: 'Texto largo',
            max_chars: 150
          },
          {
            id: 'wa_recordatorio_d2',
            nombre: 'WA Recordatorio Directo 2',
            momento: '1 día antes Directo 2',
            objetivo: 'Recordar segundo directo',
            incluir: 'Fecha, hora, promesa de valor',
            excluir: 'Precios',
            max_chars: 220
          },
          {
            id: 'wa_link_d2',
            nombre: 'WA Link Directo 2',
            momento: 'Al empezar Directo 2',
            objetivo: 'Enviar link de acceso',
            incluir: 'Link directo, mensaje corto',
            excluir: 'Texto largo',
            max_chars: 150
          },
          {
            id: 'wa_recordatorio_d3',
            nombre: 'WA Recordatorio Directo 3',
            momento: '1 día antes Directo 3',
            objetivo: 'Recordar el directo de cierre/venta',
            incluir: 'Fecha, hora, anticipar que habrá sorpresa',
            excluir: 'Revelar precio',
            max_chars: 220
          },
          {
            id: 'wa_link_d3',
            nombre: 'WA Link Directo 3',
            momento: 'Al empezar Directo 3',
            objetivo: 'Enviar link al directo de cierre',
            incluir: 'Link directo, urgencia',
            excluir: 'Texto largo',
            max_chars: 150
          },
          {
            id: 'wa_oferta',
            nombre: 'WA Oferta Abierta',
            momento: 'Tras Directo 3 — apertura carrito',
            objetivo: 'Anunciar oferta con urgencia',
            incluir: 'Precio, bonus, deadline, link de compra',
            excluir: 'Vaguedades',
            max_chars: 350
          },
          {
            id: 'wa_urgencia',
            nombre: 'WA Urgencia',
            momento: '24h antes del cierre',
            objetivo: 'Crear urgencia de cierre',
            incluir: 'Horas que quedan, lo que pierden, link',
            excluir: 'Explicaciones largas',
            max_chars: 250
          },
          {
            id: 'wa_cierre',
            nombre: 'WA Último Aviso',
            momento: '2h antes del cierre definitivo',
            objetivo: 'Último mensaje de cierre',
            incluir: 'Urgencia máxima, link directo',
            excluir: 'Todo lo que no sea urgencia',
            max_chars: 180
          }
        ],
        adCreatives: [
          // FASE CAPTACIÓN (8)
          { id: 'cap_video_intriga', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Intriga — Problema/Promesa' },
          { id: 'cap_imagen_headline', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Headline Principal' },
          { id: 'cap_story_directo1', tipo: 'captacion', formato: 'story', nombre: 'Story — Directo 1 Cuenta Atrás' },
          { id: 'cap_story_directo2', tipo: 'captacion', formato: 'story', nombre: 'Story — Directo 2 Cuenta Atrás' },
          { id: 'cap_story_directo3', tipo: 'captacion', formato: 'story', nombre: 'Story — Directo 3 Cuenta Atrás' },
          { id: 'cap_reel_problema', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Problema del Avatar' },
          { id: 'cap_reel_promesa', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Promesa/Transformación' },
          { id: 'cap_testimonio_video', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — Resultado' },
          // FASE VENTA (10)
          { id: 'ven_video_oferta', tipo: 'venta', formato: 'video', nombre: 'Vídeo Oferta — Qué incluye + Precio' },
          { id: 'ven_imagen_urgencia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Urgencia — Cierra en X horas' },
          { id: 'ven_story_cierre', tipo: 'venta', formato: 'story', nombre: 'Story — Últimas horas' },
          { id: 'ven_retargeting_objecion1', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción precio' },
          { id: 'ven_retargeting_objecion2', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción tiempo' },
          { id: 'ven_retargeting_objecion3', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción resultados' },
          { id: 'ven_testimonio_resultado', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Testimonio — Resultado concreto' },
          { id: 'ven_imagen_garantia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Garantía + Bonus' },
          { id: 'ven_video_urgencia_final', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre final 2h' },
          { id: 'ven_imagen_stack', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Stack de valor completo' },
        ]
      },
      {
        id: "serie-lives",
        label: "Serie de Lives",
        description: "Lives en redes sociales con replays disponibles y carrito abierto por tiempo limitado.",
        defaultAssets: {
          cartHours: 96,
          landings: ["Página de Aviso (Opt-in)", "Página Puente (Únete a WA)", "Página de Ventas", "Gracias por Compra"],
          emails: 10,
          whatsapp: 8,
          adCopies: 3,
          adCreatives: 18
        },
        emails: [
          { 
            id: 'email_bienvenida', 
            nombre: 'Email Bienvenida', 
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar registro y presentar la serie de lives',
            incluir: 'Fechas de los lives, dónde se harán (IG/YouTube), link para notificaciones',
            excluir: 'Precios, ofertas, ventas',
            max_words: 180
          },
          { 
            id: 'email_live1_recordatorio', 
            nombre: 'Recordatorio Live 1', 
            momento: '1 día antes Live 1',
            objetivo: 'Recordar el primer live',
            incluir: 'Fecha, hora, plataforma, qué aprenderán',
            excluir: 'Ventas, precios',
            max_words: 150
          },
          { 
            id: 'email_live1_ahora', 
            nombre: 'Live 1 — Estamos en Directo', 
            momento: 'Al empezar Live 1',
            objetivo: 'Llevar gente al live',
            incluir: 'Link directo a la plataforma',
            excluir: 'Texto largo',
            max_words: 80
          },
          { 
            id: 'email_live2_recordatorio', 
            nombre: 'Recordatorio Live 2', 
            momento: '1 día antes Live 2',
            objetivo: 'Recordar segundo live',
            incluir: 'Fecha, hora, plataforma, promesa de valor',
            excluir: 'Ventas directas',
            max_words: 150
          },
          { 
            id: 'email_live2_ahora', 
            nombre: 'Live 2 — Estamos en Directo', 
            momento: 'Al empezar Live 2',
            objetivo: 'Llevar gente al live',
            incluir: 'Link directo',
            excluir: 'Texto largo',
            max_words: 80
          },
          { 
            id: 'email_live3_recordatorio', 
            nombre: 'Recordatorio Live 3', 
            momento: '1 día antes Live 3',
            objetivo: 'Recordar el live de cierre',
            incluir: 'Fecha, hora, anticipar sorpresa/oferta',
            excluir: 'Revelar precio',
            max_words: 150
          },
          { 
            id: 'email_live3_ahora', 
            nombre: 'Live 3 — Estamos en Directo', 
            momento: 'Al empezar Live 3',
            objetivo: 'Llevar gente al live de cierre',
            incluir: 'Link directo, urgencia',
            excluir: 'Todo lo que no sea link',
            max_words: 80
          },
          { 
            id: 'email_apertura', 
            nombre: 'Apertura de Carrito', 
            momento: 'Post Live 3',
            objetivo: 'Anunciar oferta',
            incluir: 'Precio, bonus, deadline, link de compra, garantía',
            excluir: 'Contenido educativo',
            max_words: 250
          },
          { 
            id: 'email_urgencia', 
            nombre: 'Urgencia — Cierra Pronto', 
            momento: '24h antes del cierre',
            objetivo: 'Crear urgencia',
            incluir: 'Horas que quedan, lo que pierden, link',
            excluir: 'Explicaciones largas',
            max_words: 150
          },
          { 
            id: 'email_cierre', 
            nombre: 'Último Aviso — Cierre', 
            momento: 'Últimas horas',
            objetivo: 'Último empujón',
            incluir: 'Urgencia máxima, link directo, qué pierden',
            excluir: 'Todo lo que no sea urgencia',
            max_words: 120
          }
        ],
        whatsapp: [
          {
            id: 'wa_confirmacion',
            nombre: 'WA Confirmación',
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar inscripción a la serie',
            incluir: 'Fechas de los lives, link de grupo/canal',
            excluir: 'Precios, ofertas',
            max_chars: 280
          },
          {
            id: 'wa_live1',
            nombre: 'WA Live 1 Ahora',
            momento: 'Al empezar Live 1',
            objetivo: 'Avisar que el live está en directo',
            incluir: 'Link a la plataforma, mensaje corto',
            excluir: 'Texto largo',
            max_chars: 150
          },
          {
            id: 'wa_live2',
            nombre: 'WA Live 2 Ahora',
            momento: 'Al empezar Live 2',
            objetivo: 'Avisar que el live está en directo',
            incluir: 'Link a la plataforma',
            excluir: 'Texto largo',
            max_chars: 150
          },
          {
            id: 'wa_live3',
            nombre: 'WA Live 3 Ahora',
            momento: 'Al empezar Live 3',
            objetivo: 'Avisar del live de cierre',
            incluir: 'Link, anticipar sorpresa',
            excluir: 'Revelar precio',
            max_chars: 150
          },
          {
            id: 'wa_replays',
            nombre: 'WA Replays Disponibles',
            momento: 'Post Live 3',
            objetivo: 'Compartir replays de la serie',
            incluir: 'Links a replays, tiempo disponible',
            excluir: 'Venta directa',
            max_chars: 280
          },
          {
            id: 'wa_oferta',
            nombre: 'WA Oferta Especial',
            momento: 'Tras Live 3 — apertura carrito',
            objetivo: 'Anunciar oferta',
            incluir: 'Precio, bonus, deadline, link de compra',
            excluir: 'Vaguedades',
            max_chars: 350
          },
          {
            id: 'wa_urgencia',
            nombre: 'WA Urgencia',
            momento: '24h antes del cierre',
            objetivo: 'Crear urgencia',
            incluir: 'Horas que quedan, lo que pierden, link',
            excluir: 'Explicaciones largas',
            max_chars: 250
          },
          {
            id: 'wa_cierre',
            nombre: 'WA Último Aviso',
            momento: '2h antes del cierre',
            objetivo: 'Último mensaje',
            incluir: 'Urgencia máxima, link directo',
            excluir: 'Todo lo que no sea urgencia',
            max_chars: 180
          }
        ],
        adCreatives: [
          // FASE CAPTACIÓN (10)
          { id: 'cap_video_live1', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Promo — Live 1' },
          { id: 'cap_video_live2', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Promo — Live 2' },
          { id: 'cap_video_live3', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Promo — Live 3' },
          { id: 'cap_story_live1', tipo: 'captacion', formato: 'story', nombre: 'Story — Live 1 Cuenta Atrás' },
          { id: 'cap_story_live2', tipo: 'captacion', formato: 'story', nombre: 'Story — Live 2 Cuenta Atrás' },
          { id: 'cap_story_live3', tipo: 'captacion', formato: 'story', nombre: 'Story — Live 3 Cuenta Atrás' },
          { id: 'cap_reel_problema', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Problema del Avatar' },
          { id: 'cap_reel_promesa', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Promesa/Transformación' },
          { id: 'cap_imagen_headline', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Headline Principal' },
          { id: 'cap_testimonio_video', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — Resultado' },
          // FASE VENTA (8)
          { id: 'ven_video_oferta', tipo: 'venta', formato: 'video', nombre: 'Vídeo Oferta — Qué incluye + Precio' },
          { id: 'ven_imagen_urgencia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Urgencia — Carrito cierra pronto' },
          { id: 'ven_story_cierre', tipo: 'venta', formato: 'story', nombre: 'Story — Últimas horas' },
          { id: 'ven_retargeting_objecion1', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción precio' },
          { id: 'ven_retargeting_objecion2', tipo: 'venta', formato: 'video', nombre: 'Vídeo Retargeting — Objeción tiempo' },
          { id: 'ven_testimonio_resultado', tipo: 'venta', formato: 'imagen', nombre: 'Imagen Testimonio — Resultado concreto' },
          { id: 'ven_imagen_garantia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Garantía + Bonus' },
          { id: 'ven_video_urgencia_final', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre final 2h' },
        ]
      }
    ]
  },

  // ============================================
  // 🌿 EVERGREEN AUTOMATIZADO
  // ============================================
  {
    id: "evergreen",
    label: "Evergreen",
    icon: "🌿",
    color: "#22C55E",
    description: "Funnels automatizados que venden 24/7 sin intervención manual.",
    separar_fases_creativos: false,
    variants: [
      {
        id: "vsl-funnel",
        label: "VSL Funnel",
        description: "Video Sales Letter: captura → vídeo de venta → checkout. Simple y efectivo.",
        defaultAssets: {
          landings: ["Captura Opt-in", "Página VSL", "Checkout", "Thank You"],
          emails: 7,
          whatsapp: 3,
          adCopies: 5,
          adCreatives: 6
        },
        emails: [
          {
            id: 'email_entrega',
            nombre: 'Entrega del Recurso',
            momento: 'Inmediato tras opt-in',
            objetivo: 'Entregar el lead magnet y dirigir al VSL',
            incluir: 'Link de descarga, link al VSL, beneficio principal',
            excluir: 'Venta directa, precios',
            max_words: 150
          },
          {
            id: 'email_recuerda_vsl',
            nombre: 'Recuerda Ver el Vídeo',
            momento: '+24h si no vio VSL',
            objetivo: 'Recuperar a quien no vio el vídeo',
            incluir: 'Link al VSL, qué se perderán si no lo ven',
            excluir: 'Precio, presión excesiva',
            max_words: 120
          },
          {
            id: 'email_valor',
            nombre: 'Email de Valor',
            momento: '+48h',
            objetivo: 'Dar valor y generar confianza',
            incluir: 'Tip útil relacionado, historia breve, link al VSL',
            excluir: 'Venta directa',
            max_words: 180
          },
          {
            id: 'email_caso_exito',
            nombre: 'Caso de Éxito',
            momento: '+72h',
            objetivo: 'Mostrar prueba social',
            incluir: 'Testimonio específico, resultados concretos, link VSL',
            excluir: 'Historias genéricas',
            max_words: 180
          },
          {
            id: 'email_oferta',
            nombre: 'Oferta Especial',
            momento: '+96h',
            objetivo: 'Presentar la oferta con deadline',
            incluir: 'Precio, bonus, deadline (48h), link de compra',
            excluir: 'Contenido educativo',
            max_words: 220
          },
          {
            id: 'email_urgencia',
            nombre: 'Urgencia — 24h',
            momento: '+120h',
            objetivo: 'Crear urgencia de cierre',
            incluir: 'Horas que quedan, lo que pierden, link directo',
            excluir: 'Contenido nuevo',
            max_words: 140
          },
          {
            id: 'email_cierre',
            nombre: 'Última Oportunidad',
            momento: '+144h',
            objetivo: 'Último empujón',
            incluir: 'Urgencia máxima, link directo, cierra en X horas',
            excluir: 'Todo lo que no sea urgencia',
            max_words: 100
          }
        ],
        whatsapp: [
          {
            id: 'wa_entrega',
            nombre: 'WA Entrega Recurso',
            momento: 'Inmediato tras opt-in',
            objetivo: 'Entregar recurso y dirigir al VSL',
            incluir: 'Link de descarga, link VSL, emoji celebración',
            excluir: 'Ventas, precios',
            max_chars: 250
          },
          {
            id: 'wa_oferta',
            nombre: 'WA Oferta Especial',
            momento: 'Tras deadline activado',
            objetivo: 'Anunciar oferta con urgencia',
            incluir: 'Precio, bonus principal, deadline, link',
            excluir: 'Texto largo',
            max_chars: 300
          },
          {
            id: 'wa_cierre',
            nombre: 'WA Cierre',
            momento: 'Últimas 6h de deadline',
            objetivo: 'Último aviso de cierre',
            incluir: 'Urgencia, link directo, qué pierden',
            excluir: 'Todo lo que no sea urgencia',
            max_chars: 180
          }
        ],
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación - Dolor Principal', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación - Identificación', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación - Curiosidad', tipo: 'captacion', orden: 3 },
          { id: 'venta_1', nombre: 'Venta - Transformación', tipo: 'venta', orden: 4 },
          { id: 'venta_2', nombre: 'Venta - Urgencia Final', tipo: 'venta', orden: 5 }
        ]
      },
      {
        id: "webinar-automatizado",
        label: "Webinar Automatizado",
        description: "Webinar pregrabado que simula directo. Escasez con deadline automatizado.",
        defaultAssets: {
          landings: ["Registro Webinar", "Sala del Webinar", "Replay", "Página de Ventas", "Checkout"],
          emails: 10,
          whatsapp: 5,
          adCopies: 5,
          adCreatives: 5
        },
        emails: [
          {
            id: 'email_confirmacion',
            nombre: 'Confirmación de Registro',
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar registro y generar expectativa',
            incluir: 'Fecha/hora del webinar, link de acceso, qué aprenderán',
            excluir: 'Precios, ventas',
            max_words: 160
          },
          {
            id: 'email_recordatorio_24h',
            nombre: 'Recordatorio 24h Antes',
            momento: '24h antes del webinar',
            objetivo: 'Recordar y aumentar anticipación',
            incluir: 'Fecha, hora, link, beneficio de asistir en vivo',
            excluir: 'Precios',
            max_words: 130
          },
          {
            id: 'email_recordatorio_1h',
            nombre: 'Recordatorio 1h Antes',
            momento: '1h antes del webinar',
            objetivo: 'Recordatorio urgente',
            incluir: 'Link directo, empieza en 1 hora',
            excluir: 'Texto largo',
            max_words: 80
          },
          {
            id: 'email_empieza_ahora',
            nombre: 'Empieza Ahora',
            momento: 'Al empezar el webinar',
            objetivo: 'Llevar al webinar',
            incluir: 'Link directo, empezamos ya',
            excluir: 'Todo lo que no sea link',
            max_words: 60
          },
          {
            id: 'email_replay',
            nombre: 'Replay Disponible',
            momento: '+2h post webinar',
            objetivo: 'Enviar replay y preparar venta',
            incluir: 'Link al replay, tiempo límite del replay, resumen',
            excluir: 'Venta agresiva',
            max_words: 160
          },
          {
            id: 'email_oferta',
            nombre: 'Oferta Especial',
            momento: '+12h post webinar',
            objetivo: 'Presentar oferta con deadline',
            incluir: 'Precio, bonus, deadline (48h), link de compra, garantía',
            excluir: 'Contenido educativo',
            max_words: 250
          },
          {
            id: 'email_objecion',
            nombre: 'Resolviendo Dudas',
            momento: '+24h post webinar',
            objetivo: 'Resolver objeción principal',
            incluir: 'Objeción común, respuesta clara, link',
            excluir: 'Presión excesiva',
            max_words: 180
          },
          {
            id: 'email_testimonio',
            nombre: 'Resultado de Alumno',
            momento: '+36h post webinar',
            objetivo: 'Mostrar prueba social',
            incluir: 'Testimonio específico, resultado concreto, link',
            excluir: 'Historias genéricas',
            max_words: 180
          },
          {
            id: 'email_urgencia',
            nombre: 'Urgencia — Quedan 12h',
            momento: '-12h deadline',
            objetivo: 'Crear urgencia',
            incluir: 'Horas que quedan, bonus que desaparecen, link',
            excluir: 'Contenido nuevo',
            max_words: 140
          },
          {
            id: 'email_cierre',
            nombre: 'Cierre Definitivo',
            momento: '-2h deadline',
            objetivo: 'Último empujón',
            incluir: 'Urgencia máxima, link directo, qué pierden',
            excluir: 'Todo lo que no sea urgencia',
            max_words: 100
          }
        ],
        whatsapp: [
          {
            id: 'wa_confirmacion',
            nombre: 'WA Confirmación',
            momento: 'Inmediato tras registro',
            objetivo: 'Confirmar registro',
            incluir: 'Fecha, hora, link de acceso',
            excluir: 'Ventas',
            max_chars: 220
          },
          {
            id: 'wa_recordatorio',
            nombre: 'WA Recordatorio',
            momento: '1h antes del webinar',
            objetivo: 'Recordatorio urgente',
            incluir: 'Link directo, empieza en 1 hora',
            excluir: 'Texto largo',
            max_chars: 150
          },
          {
            id: 'wa_empieza',
            nombre: 'WA Empieza Ahora',
            momento: 'Al empezar',
            objetivo: 'Enviar link inmediato',
            incluir: 'Link directo, empezamos',
            excluir: 'Todo excepto link',
            max_chars: 120
          },
          {
            id: 'wa_oferta',
            nombre: 'WA Oferta',
            momento: 'Post webinar',
            objetivo: 'Anunciar oferta',
            incluir: 'Precio, bonus, deadline, link',
            excluir: 'Texto largo',
            max_chars: 300
          },
          {
            id: 'wa_cierre',
            nombre: 'WA Cierre',
            momento: 'Últimas horas',
            objetivo: 'Último aviso',
            incluir: 'Urgencia, link directo',
            excluir: 'Todo excepto urgencia',
            max_chars: 180
          }
        ],
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación - Promesa del Webinar', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación - Anticipación', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación - Social Proof', tipo: 'captacion', orden: 3 },
          { id: 'venta_1', nombre: 'Venta - Oferta Irresistible', tipo: 'venta', orden: 4 },
          { id: 'venta_2', nombre: 'Venta - Cierre con Escasez', tipo: 'venta', orden: 5 }
        ]
      },
      {
        id: "tripwire-funnel",
        label: "Tripwire Funnel",
        description: "Oferta de bajo coste (€7-47) → Upsells → Oferta principal. Auto-liquidante.",
        defaultAssets: {
          landings: ["Captura Lead Magnet", "Oferta Tripwire", "Upsell 1", "Upsell 2", "Downsell", "Thank You"],
          emails: 6,
          whatsapp: 2,
          adCopies: 4,
          adCreatives: 4
        },
        emails: [
          {
            id: 'email_lead_magnet',
            nombre: 'Entrega Lead Magnet',
            momento: 'Inmediato tras opt-in',
            objetivo: 'Entregar lead magnet y presentar tripwire',
            incluir: 'Link descarga, mención de oferta especial por ser nuevo',
            excluir: 'Presión de venta',
            max_words: 150
          },
          {
            id: 'email_tripwire',
            nombre: 'Oferta Tripwire',
            momento: '+4h',
            objetivo: 'Presentar oferta tripwire irresistible',
            incluir: 'Precio bajo (€7-47), qué incluye, link de compra',
            excluir: 'Mencionar oferta principal',
            max_words: 180
          },
          {
            id: 'email_valor_tripwire',
            nombre: 'Lo Que Incluye Tu Tripwire',
            momento: '+24h (compradores)',
            objetivo: 'Dar valor y preparar upsell',
            incluir: 'Cómo aprovechar la compra, anticipar siguiente nivel',
            excluir: 'Presión de venta',
            max_words: 160
          },
          {
            id: 'email_upsell',
            nombre: 'Oferta Principal',
            momento: '+48h (compradores)',
            objetivo: 'Presentar oferta principal con descuento por ser cliente',
            incluir: 'Precio especial cliente, bonus exclusivo, link',
            excluir: 'Repetir tripwire',
            max_words: 220
          },
          {
            id: 'email_no_compro_tripwire',
            nombre: 'Última Oportunidad Tripwire',
            momento: '+48h (no compradores)',
            objetivo: 'Recuperar a quien no compró tripwire',
            incluir: 'Precio, valor excepcional, link, deadline',
            excluir: 'Oferta principal',
            max_words: 160
          },
          {
            id: 'email_cierre',
            nombre: 'Cierre de Ofertas',
            momento: '+72h',
            objetivo: 'Último aviso de ofertas disponibles',
            incluir: 'Qué ofertas terminan, links, urgencia',
            excluir: 'Contenido nuevo',
            max_words: 140
          }
        ],
        whatsapp: [
          {
            id: 'wa_entrega',
            nombre: 'WA Lead Magnet',
            momento: 'Inmediato',
            objetivo: 'Entregar lead magnet',
            incluir: 'Link descarga, bienvenida',
            excluir: 'Venta directa',
            max_chars: 200
          },
          {
            id: 'wa_tripwire',
            nombre: 'WA Tripwire',
            momento: '+24h',
            objetivo: 'Recordar oferta tripwire',
            incluir: 'Precio bajo, link, deadline',
            excluir: 'Texto largo',
            max_chars: 220
          }
        ],
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación - Lead Magnet', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación - Valor Gratuito', tipo: 'captacion', orden: 2 },
          { id: 'venta_1', nombre: 'Venta - Tripwire Irresistible', tipo: 'venta', orden: 3 },
          { id: 'venta_2', nombre: 'Venta - Upsell Stack', tipo: 'venta', orden: 4 }
        ]
      },
      {
        id: "quiz-funnel",
        label: "Quiz Funnel",
        description: "Cuestionario de segmentación → Resultado personalizado → Oferta específica.",
        defaultAssets: {
          landings: ["Inicio Quiz", "Resultado Perfil A", "Resultado Perfil B", "Resultado Perfil C", "Página de Ventas"],
          emails: 8,
          whatsapp: 4,
          adCopies: 6,
          adCreatives: 6
        },
        emails: [
          {
            id: 'email_resultado',
            nombre: 'Tu Resultado del Quiz',
            momento: 'Inmediato tras completar quiz',
            objetivo: 'Entregar resultado personalizado',
            incluir: 'Perfil identificado, fortalezas, áreas de mejora, link a resultado completo',
            excluir: 'Venta directa',
            max_words: 200
          },
          {
            id: 'email_profundiza',
            nombre: 'Profundizando en Tu Perfil',
            momento: '+24h',
            objetivo: 'Dar más valor sobre el perfil',
            incluir: 'Insights adicionales, tips específicos para su perfil',
            excluir: 'Venta agresiva',
            max_words: 180
          },
          {
            id: 'email_caso_perfil',
            nombre: 'Historia de Alguien Como Tú',
            momento: '+48h',
            objetivo: 'Mostrar caso de éxito del mismo perfil',
            incluir: 'Testimonio de persona con mismo perfil, transformación',
            excluir: 'Perfiles diferentes',
            max_words: 200
          },
          {
            id: 'email_solucion',
            nombre: 'La Solución Para Tu Perfil',
            momento: '+72h',
            objetivo: 'Introducir la oferta como solución personalizada',
            incluir: 'Por qué esta solución es perfecta para su perfil',
            excluir: 'Precio todavía',
            max_words: 180
          },
          {
            id: 'email_oferta',
            nombre: 'Oferta Personalizada',
            momento: '+96h',
            objetivo: 'Presentar oferta con descuento por perfil específico',
            incluir: 'Precio, bonus exclusivo para su perfil, deadline, link',
            excluir: 'Contenido genérico',
            max_words: 250
          },
          {
            id: 'email_objecion',
            nombre: 'Dudas Comunes de Tu Perfil',
            momento: '+120h',
            objetivo: 'Resolver objeciones típicas de ese perfil',
            incluir: 'Objeciones específicas del perfil, respuestas, link',
            excluir: 'Objeciones de otros perfiles',
            max_words: 180
          },
          {
            id: 'email_urgencia',
            nombre: 'Tu Oferta Caduca',
            momento: '+144h',
            objetivo: 'Crear urgencia',
            incluir: 'Horas que quedan, descuento que pierde, link',
            excluir: 'Contenido nuevo',
            max_words: 140
          },
          {
            id: 'email_cierre',
            nombre: 'Última Oportunidad',
            momento: '+168h',
            objetivo: 'Cierre final',
            incluir: 'Urgencia máxima, link directo, qué pierden',
            excluir: 'Todo lo que no sea urgencia',
            max_words: 100
          }
        ],
        whatsapp: [
          {
            id: 'wa_resultado',
            nombre: 'WA Tu Resultado',
            momento: 'Inmediato tras quiz',
            objetivo: 'Entregar resultado y celebrar',
            incluir: 'Perfil identificado, link a resultado completo',
            excluir: 'Venta',
            max_chars: 220
          },
          {
            id: 'wa_tip',
            nombre: 'WA Tip Para Tu Perfil',
            momento: '+48h',
            objetivo: 'Dar valor específico',
            incluir: 'Tip útil para su perfil, emoji',
            excluir: 'Venta directa',
            max_chars: 200
          },
          {
            id: 'wa_oferta',
            nombre: 'WA Oferta Perfil',
            momento: '+96h',
            objetivo: 'Anunciar oferta personalizada',
            incluir: 'Descuento exclusivo para su perfil, link, deadline',
            excluir: 'Texto largo',
            max_chars: 280
          },
          {
            id: 'wa_cierre',
            nombre: 'WA Cierre',
            momento: 'Últimas horas',
            objetivo: 'Último aviso',
            incluir: 'Urgencia, link directo',
            excluir: 'Todo excepto urgencia',
            max_chars: 180
          }
        ],
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación - Intriga Quiz', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación - Auto-descubrimiento', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación - Resultado Teaser', tipo: 'captacion', orden: 3 },
          { id: 'venta_1', nombre: 'Venta - Solución Personalizada', tipo: 'venta', orden: 4 },
          { id: 'venta_2', nombre: 'Venta - Oferta Exclusiva', tipo: 'venta', orden: 5 },
          { id: 'venta_3', nombre: 'Venta - Cierre Directo', tipo: 'venta', orden: 6 }
        ]
      }
    ]
  },

  // ============================================
  // 📦 PLF - PRODUCT LAUNCH FORMULA
  // ============================================
  {
    id: "plf",
    label: "PLF",
    icon: "📦",
    color: "#F59E0B",
    description: "Product Launch Formula: serie de vídeos de alto valor para educar y vender con máxima autoridad.",
    separar_fases_creativos: true,
    variants: [
      {
        id: "plf-clasico",
        label: "PLF Clásico 4 Vídeos",
        description: "Vídeo 1: Oportunidad → V2: Transformación → V3: Experiencia → V4: Oferta + Carrito.",
        defaultAssets: {
          cartHours: 168,
          landings: ["Página de Registro", "Página Puente (Únete a WA)", "Página Gracias (Pixel Lead)", "Sala Vídeo 1", "Sala Vídeo 2", "Sala Vídeo 3", "Sala Vídeo 4 + Ventas", "Checkout", "Gracias por Compra (Pixel Purchase)"],
          emails: 18,
          whatsapp: 12,
          adCopies: 10,
          adCreatives: 8
        },
        emails: [
          { id: 'email_bienvenida', nombre: 'Bienvenida a la Serie', momento: 'Inmediato tras registro', objetivo: 'Confirmar registro y presentar la serie de 4 vídeos', incluir: 'Fechas de los 4 vídeos, qué aprenderán, link de acceso', excluir: 'Precios, ventas', max_words: 200 },
          { id: 'email_v1_disponible', nombre: 'Vídeo 1 Disponible', momento: 'Día de lanzamiento V1', objetivo: 'Anunciar que V1 está disponible', incluir: 'Link al vídeo, qué van a descubrir, urgencia de verlo', excluir: 'Precios', max_words: 150 },
          { id: 'email_v1_recordatorio', nombre: 'Recordatorio V1', momento: '+24h V1', objetivo: 'Recuperar a quien no vio V1', incluir: 'Link, resumen de lo que se perdieron, qué viene en V2', excluir: 'Venta', max_words: 140 },
          { id: 'email_v2_disponible', nombre: 'Vídeo 2 Disponible', momento: 'Día de lanzamiento V2', objetivo: 'Anunciar V2 (Transformación)', incluir: 'Link, promesa del vídeo, conexión con V1', excluir: 'Precios', max_words: 150 },
          { id: 'email_v2_recordatorio', nombre: 'Recordatorio V2', momento: '+24h V2', objetivo: 'Recuperar a quien no vio V2', incluir: 'Link, resumen, anticipar V3', excluir: 'Venta directa', max_words: 140 },
          { id: 'email_v3_disponible', nombre: 'Vídeo 3 Disponible', momento: 'Día de lanzamiento V3', objetivo: 'Anunciar V3 (Experiencia/Método)', incluir: 'Link, promesa del vídeo, casos de éxito', excluir: 'Precio todavía', max_words: 150 },
          { id: 'email_v3_recordatorio', nombre: 'Recordatorio V3', momento: '+24h V3', objetivo: 'Recuperar a quien no vio V3', incluir: 'Link, resumen, anticipar la gran revelación en V4', excluir: 'Revelar precio', max_words: 140 },
          { id: 'email_v4_disponible', nombre: 'Vídeo 4 + Oferta', momento: 'Día de lanzamiento V4', objetivo: 'Anunciar V4 con la oferta', incluir: 'Link al vídeo, anticipar oferta especial', excluir: 'Precio en email (que lo vean en vídeo)', max_words: 150 },
          { id: 'email_apertura', nombre: 'Carrito Abierto', momento: 'Post V4', objetivo: 'Anunciar apertura oficial', incluir: 'Precio, bonus, deadline (7 días), link, garantía', excluir: 'Contenido educativo', max_words: 280 },
          { id: 'email_faq', nombre: 'Preguntas Frecuentes', momento: '+24h apertura', objetivo: 'Resolver dudas comunes', incluir: 'FAQs principales, respuestas claras, link', excluir: 'Presión excesiva', max_words: 250 },
          { id: 'email_testimonio1', nombre: 'Testimonio Destacado', momento: '+48h apertura', objetivo: 'Mostrar prueba social', incluir: 'Historia de éxito detallada, resultado concreto', excluir: 'Historias genéricas', max_words: 200 },
          { id: 'email_objecion_precio', nombre: 'Objeción Precio', momento: '+72h apertura', objetivo: 'Resolver objeción de precio', incluir: 'ROI, comparativa, facilidades de pago', excluir: 'Presión', max_words: 220 },
          { id: 'email_objecion_tiempo', nombre: 'Objeción Tiempo', momento: '+96h apertura', objetivo: 'Resolver objeción de tiempo', incluir: 'Cómo funciona el programa, flexibilidad', excluir: 'Falsas promesas', max_words: 200 },
          { id: 'email_bonus_expira', nombre: 'Bonus Expira', momento: '+120h apertura', objetivo: 'Urgencia de bonus', incluir: 'Bonus que desaparece, valor, deadline', excluir: 'Contenido nuevo', max_words: 160 },
          { id: 'email_testimonio2', nombre: 'Más Resultados', momento: '+144h apertura', objetivo: 'Más prueba social', incluir: 'Múltiples testimonios cortos, resultados', excluir: 'Una sola historia', max_words: 200 },
          { id: 'email_48h', nombre: 'Quedan 48h', momento: '-48h cierre', objetivo: 'Urgencia de cierre', incluir: 'Horas que quedan, resumen oferta, link', excluir: 'Contenido nuevo', max_words: 150 },
          { id: 'email_24h', nombre: 'Última Oportunidad', momento: '-24h cierre', objetivo: 'Urgencia máxima', incluir: 'Urgencia, lo que pierden, link', excluir: 'Explicaciones', max_words: 120 },
          { id: 'email_cierre', nombre: 'Cierre Definitivo', momento: '-2h cierre', objetivo: 'Último empujón', incluir: 'Cierra en X horas, link directo, despedida', excluir: 'Todo excepto urgencia', max_words: 100 }
        ],
        whatsapp: [
          { id: 'wa_confirmacion', nombre: 'WA Confirmación', momento: 'Inmediato', objetivo: 'Confirmar registro', incluir: 'Bienvenida, fechas de vídeos, link grupo', excluir: 'Ventas', max_chars: 280 },
          { id: 'wa_v1', nombre: 'WA Vídeo 1', momento: 'Al publicar V1', objetivo: 'Avisar V1 disponible', incluir: 'Link directo, qué van a descubrir', excluir: 'Texto largo', max_chars: 180 },
          { id: 'wa_v2', nombre: 'WA Vídeo 2', momento: 'Al publicar V2', objetivo: 'Avisar V2 disponible', incluir: 'Link directo, promesa del vídeo', excluir: 'Texto largo', max_chars: 180 },
          { id: 'wa_v3', nombre: 'WA Vídeo 3', momento: 'Al publicar V3', objetivo: 'Avisar V3 disponible', incluir: 'Link directo, casos de éxito', excluir: 'Texto largo', max_chars: 180 },
          { id: 'wa_v4', nombre: 'WA Vídeo 4', momento: 'Al publicar V4', objetivo: 'Avisar V4 + oferta', incluir: 'Link directo, anticipar sorpresa', excluir: 'Revelar precio', max_chars: 180 },
          { id: 'wa_apertura', nombre: 'WA Carrito Abierto', momento: 'Apertura carrito', objetivo: 'Anunciar oferta', incluir: 'Precio, bonus, deadline, link', excluir: 'Vaguedades', max_chars: 320 },
          { id: 'wa_bonus', nombre: 'WA Bonus Especial', momento: '+48h apertura', objetivo: 'Recordar bonus', incluir: 'Bonus destacado, valor, link', excluir: 'Repetir todo', max_chars: 220 },
          { id: 'wa_testimonio', nombre: 'WA Resultado', momento: '+96h apertura', objetivo: 'Compartir resultado', incluir: 'Testimonio corto, resultado, link', excluir: 'Historia larga', max_chars: 200 },
          { id: 'wa_48h', nombre: 'WA 48h', momento: '-48h cierre', objetivo: 'Urgencia', incluir: 'Horas que quedan, lo que pierden, link', excluir: 'Contenido nuevo', max_chars: 220 },
          { id: 'wa_24h', nombre: 'WA 24h', momento: '-24h cierre', objetivo: 'Urgencia máxima', incluir: 'Urgencia, link directo', excluir: 'Explicaciones', max_chars: 180 },
          { id: 'wa_6h', nombre: 'WA 6h', momento: '-6h cierre', objetivo: 'Último aviso', incluir: 'Cierra pronto, link', excluir: 'Todo excepto link', max_chars: 150 },
          { id: 'wa_cierre', nombre: 'WA Cierre', momento: '-1h cierre', objetivo: 'Última llamada', incluir: 'Última hora, link directo', excluir: 'Todo excepto urgencia', max_chars: 120 }
        ],
        adCreatives: [
          { id: 'cap_video_oportunidad', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — La Oportunidad que Estás Perdiendo' },
          { id: 'cap_imagen_promesa', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Promesa de Transformación' },
          { id: 'cap_reel_problema', tipo: 'captacion', formato: 'reel', nombre: 'Reel — El Problema que Nadie Habla' },
          { id: 'cap_testimonio', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — Resultado Real' },
          { id: 'ven_video_v1_promo', tipo: 'venta', formato: 'video', nombre: 'Vídeo Promo — Vídeo 1 Disponible' },
          { id: 'ven_video_v2_promo', tipo: 'venta', formato: 'video', nombre: 'Vídeo Promo — Vídeo 2 Disponible' },
          { id: 'ven_imagen_carrito', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Carrito Abierto' },
          { id: 'ven_video_urgencia', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre de Carrito' }
        ]
      },
      {
        id: "plf-bonos",
        label: "PLF con Stack de Bonos",
        description: "PLF con bonos que se desbloquean por acción temprana. Mayor urgencia y seguimiento.",
        defaultAssets: {
          cartHours: 168,
          landings: ["Página de Registro", "Página Puente (Únete a WA)", "Página Gracias (Pixel Lead)", "Sala Vídeo 1", "Sala Vídeo 2", "Sala Vídeo 3", "Sala Vídeo 4 + Ventas", "Checkout", "Gracias por Compra"],
          emails: 22,
          whatsapp: 14,
          adCopies: 12,
          adCreatives: 10
        },
        emails: [
          { id: 'email_bienvenida', nombre: 'Bienvenida + Bonus Preview', momento: 'Inmediato', objetivo: 'Confirmar y mostrar stack de bonos', incluir: 'Fechas vídeos, preview de bonos exclusivos', excluir: 'Precios', max_words: 220 },
          { id: 'email_v1_disponible', nombre: 'Vídeo 1 + Bonus 1', momento: 'Día V1', objetivo: 'V1 disponible + primer bonus desbloqueado', incluir: 'Link V1, bonus 1 liberado para quienes vean', excluir: 'Precio', max_words: 180 },
          { id: 'email_v1_recordatorio', nombre: 'Recordatorio V1', momento: '+24h V1', objetivo: 'Urgencia de ver V1 por bonus', incluir: 'Link, bonus que se pierde si no ve', excluir: 'Venta', max_words: 150 },
          { id: 'email_v2_disponible', nombre: 'Vídeo 2 + Bonus 2', momento: 'Día V2', objetivo: 'V2 + segundo bonus', incluir: 'Link V2, bonus 2 desbloqueado', excluir: 'Precio', max_words: 180 },
          { id: 'email_v2_recordatorio', nombre: 'Recordatorio V2', momento: '+24h V2', objetivo: 'Urgencia bonus 2', incluir: 'Link, bonus que expira', excluir: 'Venta directa', max_words: 150 },
          { id: 'email_v3_disponible', nombre: 'Vídeo 3 + Bonus 3', momento: 'Día V3', objetivo: 'V3 + tercer bonus', incluir: 'Link V3, bonus 3, anticipar V4', excluir: 'Precio', max_words: 180 },
          { id: 'email_v3_recordatorio', nombre: 'Recordatorio V3', momento: '+24h V3', objetivo: 'Urgencia bonus 3', incluir: 'Link, lo que pierden', excluir: 'Revelar precio', max_words: 150 },
          { id: 'email_v4_disponible', nombre: 'Vídeo 4 + Oferta', momento: 'Día V4', objetivo: 'V4 con oferta completa', incluir: 'Link, todos los bonus acumulados', excluir: 'Precio en email', max_words: 180 },
          { id: 'email_apertura', nombre: 'Stack Completo Disponible', momento: 'Post V4', objetivo: 'Oferta con todos los bonus', incluir: 'Precio, stack completo, deadline, garantía', excluir: 'Contenido educativo', max_words: 300 },
          { id: 'email_early_bird', nombre: 'Early Bird 48h', momento: '+12h apertura', objetivo: 'Bonus extra early bird', incluir: 'Bonus adicional para primeros, deadline 48h', excluir: 'Repetir todo', max_words: 180 },
          { id: 'email_early_cierra', nombre: 'Early Bird Termina', momento: '+36h apertura', objetivo: 'Urgencia early bird', incluir: 'Horas que quedan, bonus que desaparece', excluir: 'Contenido nuevo', max_words: 140 },
          { id: 'email_faq', nombre: 'Preguntas Frecuentes', momento: '+48h apertura', objetivo: 'Resolver dudas', incluir: 'FAQs, respuestas, link', excluir: 'Presión', max_words: 250 },
          { id: 'email_testimonio1', nombre: 'Historia de Éxito', momento: '+72h apertura', objetivo: 'Prueba social', incluir: 'Testimonio detallado, bonus que usó', excluir: 'Genéricos', max_words: 200 },
          { id: 'email_objecion1', nombre: 'Objeción Principal', momento: '+96h apertura', objetivo: 'Resolver objeción', incluir: 'Objeción, respuesta, link', excluir: 'Presión', max_words: 200 },
          { id: 'email_bonus_recap', nombre: 'Recap de Todos los Bonus', momento: '+120h apertura', objetivo: 'Recordar valor total', incluir: 'Todos los bonus, valor total, link', excluir: 'Contenido nuevo', max_words: 220 },
          { id: 'email_testimonio2', nombre: 'Más Resultados', momento: '+144h apertura', objetivo: 'Más prueba social', incluir: 'Varios testimonios cortos', excluir: 'Una historia', max_words: 200 },
          { id: 'email_objecion2', nombre: 'Segunda Objeción', momento: '+156h apertura', objetivo: 'Resolver otra objeción', incluir: 'Objeción específica, respuesta', excluir: 'Repetir', max_words: 180 },
          { id: 'email_48h', nombre: 'Bonus Desaparecen 48h', momento: '-48h cierre', objetivo: 'Urgencia bonus', incluir: 'Qué bonus desaparecen, link', excluir: 'Contenido', max_words: 150 },
          { id: 'email_24h', nombre: '24h para Decidir', momento: '-24h cierre', objetivo: 'Urgencia máxima', incluir: 'Urgencia, resumen, link', excluir: 'Explicaciones', max_words: 120 },
          { id: 'email_12h', nombre: '12h — Última Llamada', momento: '-12h cierre', objetivo: 'Presión final', incluir: 'Cierra pronto, link', excluir: 'Todo excepto urgencia', max_words: 100 },
          { id: 'email_cierre', nombre: 'Cierre Definitivo', momento: '-2h cierre', objetivo: 'Último empujón', incluir: 'Cierra ya, link, despedida', excluir: 'Todo', max_words: 80 }
        ],
        whatsapp: [
          { id: 'wa_confirmacion', nombre: 'WA Bienvenida', momento: 'Inmediato', objetivo: 'Confirmar + preview bonus', incluir: 'Bienvenida, bonus que vienen', excluir: 'Ventas', max_chars: 280 },
          { id: 'wa_v1', nombre: 'WA V1 + Bonus', momento: 'Día V1', objetivo: 'V1 + bonus 1', incluir: 'Link, bonus desbloqueado', excluir: 'Largo', max_chars: 200 },
          { id: 'wa_v2', nombre: 'WA V2 + Bonus', momento: 'Día V2', objetivo: 'V2 + bonus 2', incluir: 'Link, nuevo bonus', excluir: 'Largo', max_chars: 200 },
          { id: 'wa_v3', nombre: 'WA V3 + Bonus', momento: 'Día V3', objetivo: 'V3 + bonus 3', incluir: 'Link, bonus acumulados', excluir: 'Largo', max_chars: 200 },
          { id: 'wa_v4', nombre: 'WA V4 Oferta', momento: 'Día V4', objetivo: 'V4 + oferta', incluir: 'Link, sorpresa', excluir: 'Precio', max_chars: 180 },
          { id: 'wa_apertura', nombre: 'WA Stack Completo', momento: 'Apertura', objetivo: 'Anunciar stack', incluir: 'Precio, todos bonus, deadline, link', excluir: 'Vaguedades', max_chars: 350 },
          { id: 'wa_early', nombre: 'WA Early Bird', momento: '+12h', objetivo: 'Bonus early', incluir: 'Bonus extra, deadline, link', excluir: 'Repetir', max_chars: 220 },
          { id: 'wa_early_cierra', nombre: 'WA Early Termina', momento: '+36h', objetivo: 'Urgencia early', incluir: 'Horas, bonus que pierde, link', excluir: 'Largo', max_chars: 180 },
          { id: 'wa_testimonio', nombre: 'WA Resultado', momento: '+72h', objetivo: 'Prueba social', incluir: 'Testimonio corto, link', excluir: 'Historia larga', max_chars: 200 },
          { id: 'wa_bonus_recap', nombre: 'WA Bonus Recap', momento: '+120h', objetivo: 'Recordar bonus', incluir: 'Resumen bonus, valor, link', excluir: 'Texto largo', max_chars: 250 },
          { id: 'wa_48h', nombre: 'WA 48h', momento: '-48h', objetivo: 'Urgencia', incluir: 'Bonus desaparecen, link', excluir: 'Contenido', max_chars: 200 },
          { id: 'wa_24h', nombre: 'WA 24h', momento: '-24h', objetivo: 'Urgencia máxima', incluir: 'Urgencia, link', excluir: 'Explicaciones', max_chars: 160 },
          { id: 'wa_6h', nombre: 'WA 6h', momento: '-6h', objetivo: 'Último aviso', incluir: 'Cierra pronto, link', excluir: 'Todo', max_chars: 140 },
          { id: 'wa_cierre', nombre: 'WA Cierre', momento: '-1h', objetivo: 'Final', incluir: 'Última hora, link', excluir: 'Todo', max_chars: 120 }
        ],
        adCreatives: [
          { id: 'cap_video_oportunidad', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — La Oportunidad que Estás Perdiendo' },
          { id: 'cap_imagen_promesa', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Promesa de Transformación' },
          { id: 'cap_reel_problema', tipo: 'captacion', formato: 'reel', nombre: 'Reel — El Problema que Nadie Habla' },
          { id: 'cap_testimonio', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — Resultado Real' },
          { id: 'ven_video_v1_promo', tipo: 'venta', formato: 'video', nombre: 'Vídeo Promo — Vídeo 1 Disponible' },
          { id: 'ven_video_v2_promo', tipo: 'venta', formato: 'video', nombre: 'Vídeo Promo — Vídeo 2 Disponible' },
          { id: 'ven_imagen_bono1', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Bono Desbloqueado' },
          { id: 'ven_imagen_stack', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Stack Completo de Bonos' },
          { id: 'ven_imagen_carrito', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Carrito Abierto' },
          { id: 'ven_video_urgencia', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre de Carrito' }
        ]
      },
      {
        id: "mini-plf",
        label: "Mini-PLF 3 Vídeos",
        description: "Versión compacta del PLF. 3 vídeos en menos días. Más ágil y directo al grano.",
        defaultAssets: {
          cartHours: 120,
          landings: ["Página de Registro", "Página Puente (Únete a WA)", "Página Gracias (Pixel Lead)", "Sala Vídeo 1", "Sala Vídeo 2", "Sala Vídeo 3 + Ventas", "Checkout", "Gracias por Compra"],
          emails: 12,
          whatsapp: 8,
          adCopies: 8,
          adCreatives: 6
        },
        emails: [
          { id: 'email_bienvenida', nombre: 'Bienvenida Mini-Serie', momento: 'Inmediato', objetivo: 'Confirmar y presentar 3 vídeos', incluir: 'Fechas, qué aprenderán, link', excluir: 'Precios', max_words: 180 },
          { id: 'email_v1', nombre: 'Vídeo 1 Disponible', momento: 'Día V1', objetivo: 'Anunciar V1', incluir: 'Link, promesa, urgencia', excluir: 'Precio', max_words: 140 },
          { id: 'email_v1_rec', nombre: 'Recordatorio V1', momento: '+24h V1', objetivo: 'Recuperar', incluir: 'Link, qué se pierde', excluir: 'Venta', max_words: 120 },
          { id: 'email_v2', nombre: 'Vídeo 2 Disponible', momento: 'Día V2', objetivo: 'Anunciar V2', incluir: 'Link, valor, anticipar V3', excluir: 'Precio', max_words: 140 },
          { id: 'email_v2_rec', nombre: 'Recordatorio V2', momento: '+24h V2', objetivo: 'Recuperar', incluir: 'Link, resumen', excluir: 'Revelar precio', max_words: 120 },
          { id: 'email_v3', nombre: 'Vídeo 3 + Oferta', momento: 'Día V3', objetivo: 'V3 con oferta', incluir: 'Link, anticipar oferta', excluir: 'Precio en email', max_words: 150 },
          { id: 'email_apertura', nombre: 'Carrito Abierto', momento: 'Post V3', objetivo: 'Anunciar oferta', incluir: 'Precio, bonus, deadline (5 días), link', excluir: 'Contenido', max_words: 250 },
          { id: 'email_faq', nombre: 'Dudas Frecuentes', momento: '+24h apertura', objetivo: 'Resolver dudas', incluir: 'FAQs, respuestas, link', excluir: 'Presión', max_words: 200 },
          { id: 'email_testimonio', nombre: 'Resultado Real', momento: '+48h apertura', objetivo: 'Prueba social', incluir: 'Testimonio, resultado, link', excluir: 'Genéricos', max_words: 180 },
          { id: 'email_48h', nombre: 'Quedan 48h', momento: '-48h cierre', objetivo: 'Urgencia', incluir: 'Horas, lo que pierden, link', excluir: 'Contenido', max_words: 140 },
          { id: 'email_24h', nombre: 'Última Oportunidad', momento: '-24h cierre', objetivo: 'Urgencia máxima', incluir: 'Urgencia, link', excluir: 'Explicaciones', max_words: 110 },
          { id: 'email_cierre', nombre: 'Cierre Final', momento: '-2h cierre', objetivo: 'Último empujón', incluir: 'Cierra ya, link', excluir: 'Todo', max_words: 80 }
        ],
        whatsapp: [
          { id: 'wa_confirmacion', nombre: 'WA Confirmación', momento: 'Inmediato', objetivo: 'Confirmar', incluir: 'Bienvenida, fechas', excluir: 'Ventas', max_chars: 220 },
          { id: 'wa_v1', nombre: 'WA Vídeo 1', momento: 'Día V1', objetivo: 'Avisar V1', incluir: 'Link directo', excluir: 'Largo', max_chars: 150 },
          { id: 'wa_v2', nombre: 'WA Vídeo 2', momento: 'Día V2', objetivo: 'Avisar V2', incluir: 'Link directo', excluir: 'Largo', max_chars: 150 },
          { id: 'wa_v3', nombre: 'WA Vídeo 3', momento: 'Día V3', objetivo: 'Avisar V3 + oferta', incluir: 'Link, sorpresa', excluir: 'Precio', max_chars: 160 },
          { id: 'wa_apertura', nombre: 'WA Oferta', momento: 'Apertura', objetivo: 'Anunciar oferta', incluir: 'Precio, bonus, deadline, link', excluir: 'Vaguedades', max_chars: 300 },
          { id: 'wa_48h', nombre: 'WA 48h', momento: '-48h', objetivo: 'Urgencia', incluir: 'Horas, link', excluir: 'Contenido', max_chars: 180 },
          { id: 'wa_24h', nombre: 'WA 24h', momento: '-24h', objetivo: 'Urgencia máxima', incluir: 'Urgencia, link', excluir: 'Explicaciones', max_chars: 150 },
          { id: 'wa_cierre', nombre: 'WA Cierre', momento: '-2h', objetivo: 'Final', incluir: 'Última hora, link', excluir: 'Todo', max_chars: 120 }
        ],
        adCreatives: [
          { id: 'cap_video_oportunidad', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — La Oportunidad' },
          { id: 'cap_imagen_promesa', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Promesa de Transformación' },
          { id: 'cap_reel_problema', tipo: 'captacion', formato: 'reel', nombre: 'Reel — El Problema' },
          { id: 'ven_video_promo', tipo: 'venta', formato: 'video', nombre: 'Vídeo Promo — Vídeo Disponible' },
          { id: 'ven_imagen_carrito', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Carrito Abierto' },
          { id: 'ven_video_urgencia', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre' }
        ]
      }
    ]
  },

  // ============================================
  // 🛒 ECOMMERCE
  // ============================================
  {
    id: "ecommerce",
    label: "Ecommerce",
    icon: "🛒",
    color: "#EC4899",
    description: "Estrategias específicas para tiendas online, productos físicos y ROAS directo.",
    separar_fases_creativos: false,
    variants: [
      {
        id: "venta-directa",
        label: "Venta Directa / Producto Estrella",
        description: "Tráfico frío o templado directo a un producto ganador con objetivo de conversión inmediata.",
        defaultAssets: {
          landings: ["Landing de Producto (Advertorial)", "Checkout Optimizado", "Upsell 1-Click (Order Bump)", "Gracias por Compra (Pixel Purchase)"],
          emails: 4,
          whatsapp: 2,
          adCopies: 8,
          adCreatives: 10
        },
        emails: [
          { id: 'email_bienvenida', nombre: 'Bienvenida + Descuento', momento: 'Inmediato tras suscripción', objetivo: 'Dar la bienvenida con descuento de primera compra', incluir: 'Código descuento, productos destacados, link tienda', excluir: 'Textos largos', max_words: 120 },
          { id: 'email_abandono', nombre: 'Olvidaste Algo', momento: '+1h abandono carrito', objetivo: 'Recuperar carrito abandonado', incluir: 'Producto abandonado, link directo al checkout', excluir: 'Otros productos', max_words: 100 },
          { id: 'email_abandono_descuento', nombre: 'Descuento Especial', momento: '+24h abandono', objetivo: 'Ofrecer descuento adicional', incluir: 'Descuento extra, urgencia 24h, link checkout', excluir: 'Contenido largo', max_words: 110 },
          { id: 'email_ultima_oportunidad', nombre: 'Última Oportunidad', momento: '+48h abandono', objetivo: 'Último intento de recuperación', incluir: 'Urgencia, descuento expira, link directo', excluir: 'Explicaciones', max_words: 90 }
        ],
        whatsapp: [
          { id: 'wa_abandono', nombre: 'WA Carrito Abandonado', momento: '+2h abandono', objetivo: 'Recuperar carrito', incluir: 'Producto, link checkout, emoji', excluir: 'Texto largo', max_chars: 180 },
          { id: 'wa_descuento', nombre: 'WA Descuento Final', momento: '+24h abandono', objetivo: 'Ofrecer descuento', incluir: 'Descuento, urgencia, link', excluir: 'Explicaciones', max_chars: 160 }
        ],
        piezas_requeridas: [
          { id: 'prod_1', nombre: 'Producto — Foto Principal', tipo: 'captacion', orden: 1 },
          { id: 'prod_2', nombre: 'Producto — Beneficio Clave', tipo: 'captacion', orden: 2 },
          { id: 'prod_3', nombre: 'Producto — Testimonio + Resultado', tipo: 'captacion', orden: 3 },
          { id: 'prod_4', nombre: 'Producto — Oferta + CTA Directo', tipo: 'captacion', orden: 4 },
          { id: 'ret_1', nombre: 'Retargeting — Viste Este Producto', tipo: 'venta', orden: 5 },
          { id: 'ret_2', nombre: 'Retargeting — Carrito Abandonado', tipo: 'venta', orden: 6 }
        ]
      },
      {
        id: "flash-sale",
        label: "Flash Sale 48h",
        description: "Venta relámpago con cuenta regresiva. Máxima urgencia y escasez real para inyectar liquidez.",
        defaultAssets: {
          cartHours: 48,
          landings: ["Landing Promocional Exclusiva", "Checkout Optimizado", "Upsell 1-Click", "Gracias por Compra (Pixel Purchase)"],
          emails: 6,
          whatsapp: 4,
          adCopies: 5,
          adCreatives: 6
        },
        emails: [
          { id: 'email_anuncio', nombre: 'Flash Sale Empieza', momento: 'Inicio promoción', objetivo: 'Anunciar inicio de flash sale', incluir: 'Descuento, productos, deadline 48h, link', excluir: 'Texto largo', max_words: 140 },
          { id: 'email_mejores', nombre: 'Mejores Ofertas', momento: '+6h', objetivo: 'Destacar productos estrella', incluir: 'Top productos, descuentos, links directos', excluir: 'Todos los productos', max_words: 150 },
          { id: 'email_24h', nombre: 'Quedan 24h', momento: '-24h', objetivo: 'Crear urgencia', incluir: 'Horas restantes, mejores ofertas, link', excluir: 'Contenido nuevo', max_words: 120 },
          { id: 'email_12h', nombre: 'Últimas 12h', momento: '-12h', objetivo: 'Urgencia máxima', incluir: 'Urgencia, link directo', excluir: 'Explicaciones', max_words: 100 },
          { id: 'email_6h', nombre: '6h para el Cierre', momento: '-6h', objetivo: 'Presión final', incluir: 'Cierra pronto, link', excluir: 'Todo excepto urgencia', max_words: 80 },
          { id: 'email_cierre', nombre: 'Última Hora', momento: '-1h', objetivo: 'Último empujón', incluir: 'Última hora, link directo', excluir: 'Todo', max_words: 60 }
        ],
        whatsapp: [
          { id: 'wa_inicio', nombre: 'WA Flash Sale', momento: 'Inicio', objetivo: 'Anunciar flash sale', incluir: 'Descuento, deadline, link', excluir: 'Largo', max_chars: 200 },
          { id: 'wa_24h', nombre: 'WA 24h', momento: '-24h', objetivo: 'Urgencia', incluir: 'Horas, link', excluir: 'Contenido', max_chars: 160 },
          { id: 'wa_6h', nombre: 'WA 6h', momento: '-6h', objetivo: 'Urgencia máxima', incluir: 'Urgencia, link', excluir: 'Todo', max_chars: 140 },
          { id: 'wa_cierre', nombre: 'WA Cierre', momento: '-1h', objetivo: 'Final', incluir: 'Última hora, link', excluir: 'Todo', max_chars: 120 }
        ],
        piezas_requeridas: [
          { id: 'sale_1', nombre: 'Flash Sale — Anuncio Oferta', tipo: 'captacion', orden: 1 },
          { id: 'sale_2', nombre: 'Flash Sale — Cuenta Atrás', tipo: 'captacion', orden: 2 },
          { id: 'sale_3', nombre: 'Flash Sale — Últimas Horas', tipo: 'venta', orden: 3 }
        ]
      },
      {
        id: "recuperacion-carrito",
        label: "Abandono de Carrito",
        description: "Secuencia de recuperación para usuarios que iniciaron el pago pero no compraron.",
        defaultAssets: {
          landings: ["Página de Checkout con Descuento Dinámico", "Gracias por Compra (Pixel Purchase)"],
          emails: 4,
          whatsapp: 3,
          adCopies: 3,
          adCreatives: 4
        },
        emails: [
          { id: 'email_recordatorio', nombre: 'Te Olvidaste Algo', momento: '+1h abandono', objetivo: 'Recordar carrito abandonado', incluir: 'Producto, imagen, link checkout', excluir: 'Descuentos todavía', max_words: 100 },
          { id: 'email_descuento', nombre: 'Descuento Especial', momento: '+24h abandono', objetivo: 'Ofrecer incentivo', incluir: 'Descuento 10-15%, código, link checkout', excluir: 'Presión excesiva', max_words: 110 },
          { id: 'email_urgencia', nombre: 'Tu Carrito Expira', momento: '+48h abandono', objetivo: 'Crear urgencia', incluir: 'Carrito se borra, descuento expira, link', excluir: 'Contenido nuevo', max_words: 100 },
          { id: 'email_ultimo', nombre: 'Última Oportunidad', momento: '+72h abandono', objetivo: 'Último intento', incluir: 'Urgencia máxima, mejor descuento, link', excluir: 'Explicaciones', max_words: 90 }
        ],
        whatsapp: [
          { id: 'wa_recordatorio', nombre: 'WA Olvidaste Algo', momento: '+2h abandono', objetivo: 'Recordar carrito', incluir: 'Producto, link checkout', excluir: 'Largo', max_chars: 160 },
          { id: 'wa_descuento', nombre: 'WA Descuento', momento: '+24h abandono', objetivo: 'Ofrecer descuento', incluir: 'Código, link', excluir: 'Presión', max_chars: 150 },
          { id: 'wa_ultimo', nombre: 'WA Última Oportunidad', momento: '+48h abandono', objetivo: 'Último intento', incluir: 'Urgencia, link', excluir: 'Todo excepto link', max_chars: 140 }
        ],
        piezas_requeridas: [
          { id: 'rec_1', nombre: 'Recuperación — Te Olvidaste Algo', tipo: 'captacion', orden: 1 },
          { id: 'rec_2', nombre: 'Recuperación — Descuento Especial', tipo: 'captacion', orden: 2 },
          { id: 'rec_3', nombre: 'Recuperación — Última Oportunidad', tipo: 'venta', orden: 3 }
        ]
      },
      {
        id: "lanzamiento-coleccion",
        label: "Lanzamiento Nueva Colección",
        description: "Pre-lanzamiento con lista VIP + Lanzamiento + Early access + Ofertas post-lanzamiento.",
        defaultAssets: {
          cartHours: 72,
          landings: ["Teaser / Waitlist VIP", "Landing Colección Principal", "Checkout Optimizado", "Upsell 1-Click", "Gracias por Compra (Pixel Purchase)"],
          emails: 10,
          whatsapp: 6,
          adCopies: 8,
          adCreatives: 12
        },
        emails: [
          { id: 'email_teaser', nombre: 'Algo Viene...', momento: '-7 días lanzamiento', objetivo: 'Crear anticipación', incluir: 'Teaser, fecha lanzamiento, unirse a waitlist', excluir: 'Revelar productos', max_words: 120 },
          { id: 'email_waitlist', nombre: 'Estás en la Lista VIP', momento: 'Tras unirse waitlist', objetivo: 'Confirmar VIP', incluir: 'Confirmación, beneficios early access', excluir: 'Productos todavía', max_words: 110 },
          { id: 'email_preview', nombre: 'Preview Exclusivo', momento: '-3 días', objetivo: 'Mostrar preview a VIPs', incluir: 'Fotos preview, fecha early access', excluir: 'Link de compra', max_words: 140 },
          { id: 'email_early', nombre: 'Early Access VIP', momento: '-24h lanzamiento público', objetivo: 'Dar acceso anticipado', incluir: 'Link exclusivo, descuento VIP, urgencia', excluir: 'Mencionar público', max_words: 150 },
          { id: 'email_lanzamiento', nombre: 'Ya Está Aquí', momento: 'Día lanzamiento', objetivo: 'Anunciar lanzamiento público', incluir: 'Colección, productos estrella, link', excluir: 'Mencionar VIP', max_words: 160 },
          { id: 'email_bestseller', nombre: 'Más Vendidos', momento: '+24h lanzamiento', objetivo: 'Destacar favoritos', incluir: 'Productos más vendidos, urgencia stock', excluir: 'Todos los productos', max_words: 140 },
          { id: 'email_stock', nombre: 'Stock Limitado', momento: '+48h', objetivo: 'Urgencia de stock', incluir: 'Productos agotándose, link', excluir: 'Contenido nuevo', max_words: 120 },
          { id: 'email_ultimo_dia', nombre: 'Último Día Descuento', momento: '-24h fin promo', objetivo: 'Urgencia de promoción', incluir: 'Descuento termina, link', excluir: 'Explicaciones', max_words: 110 },
          { id: 'email_6h', nombre: 'Últimas 6h', momento: '-6h fin promo', objetivo: 'Presión final', incluir: 'Urgencia, link', excluir: 'Todo', max_words: 90 },
          { id: 'email_cierre', nombre: 'Promoción Terminada', momento: 'Post promo', objetivo: 'Cerrar + next steps', incluir: 'Gracias, próximas colecciones', excluir: 'Venta', max_words: 100 }
        ],
        whatsapp: [
          { id: 'wa_teaser', nombre: 'WA Teaser', momento: '-7 días', objetivo: 'Crear anticipación', incluir: 'Algo viene, fecha', excluir: 'Productos', max_chars: 150 },
          { id: 'wa_early', nombre: 'WA Early Access', momento: '-24h', objetivo: 'Acceso VIP', incluir: 'Link exclusivo, descuento', excluir: 'Largo', max_chars: 180 },
          { id: 'wa_lanzamiento', nombre: 'WA Lanzamiento', momento: 'Día 0', objetivo: 'Anunciar', incluir: 'Ya disponible, link', excluir: 'Largo', max_chars: 160 },
          { id: 'wa_stock', nombre: 'WA Stock', momento: '+48h', objetivo: 'Urgencia stock', incluir: 'Agotándose, link', excluir: 'Contenido', max_chars: 150 },
          { id: 'wa_ultimo', nombre: 'WA Último Día', momento: '-24h', objetivo: 'Urgencia promo', incluir: 'Termina, link', excluir: 'Explicaciones', max_chars: 140 },
          { id: 'wa_cierre', nombre: 'WA Cierre', momento: '-6h', objetivo: 'Final', incluir: 'Últimas horas, link', excluir: 'Todo', max_chars: 120 }
        ],
        piezas_requeridas: [
          { id: 'launch_1', nombre: 'Teaser — Algo Viene', tipo: 'captacion', orden: 1 },
          { id: 'launch_2', nombre: 'Lanzamiento — Ya Está Aquí', tipo: 'captacion', orden: 2 },
          { id: 'launch_3', nombre: 'Colección — Producto Estrella', tipo: 'captacion', orden: 3 },
          { id: 'launch_4', nombre: 'Urgencia — Early Access', tipo: 'venta', orden: 4 }
        ]
      },
      {
        id: "black-friday",
        label: "Black Friday / Cyber Monday",
        description: "Campaña estacional con warm-up previo, ofertas escalonadas y máxima urgencia.",
        defaultAssets: {
          cartHours: 96,
          landings: ["Teaser Pre-BF", "Landing Principal Ofertas", "Checkout Optimizado", "Upsell 1-Click", "Gracias por Compra (Pixel Purchase)"],
          emails: 12,
          whatsapp: 8,
          adCopies: 10,
          adCreatives: 15
        },
        emails: [
          { id: 'email_warmup', nombre: 'Black Friday Viene', momento: '-7 días BF', objetivo: 'Crear anticipación', incluir: 'Fecha, mejores ofertas del año, unirse lista', excluir: 'Descuentos concretos', max_words: 130 },
          { id: 'email_preview', nombre: 'Preview Ofertas VIP', momento: '-3 días BF', objetivo: 'Preview a suscriptores', incluir: 'Adelanto de ofertas, ser los primeros', excluir: 'Links de compra', max_words: 140 },
          { id: 'email_early', nombre: 'Acceso Anticipado', momento: '-24h BF', objetivo: 'Early access', incluir: 'Link exclusivo, descuentos activos, urgencia', excluir: 'Mencionar público', max_words: 150 },
          { id: 'email_bf_inicio', nombre: 'Black Friday Empieza', momento: 'Viernes 00:00', objetivo: 'Anunciar inicio', incluir: 'Ofertas principales, hasta X% dto, link', excluir: 'Todos los productos', max_words: 160 },
          { id: 'email_bf_mejores', nombre: 'Las Mejores Ofertas', momento: 'Viernes mediodía', objetivo: 'Destacar top deals', incluir: 'Productos estrella, descuentos, links', excluir: 'Ofertas menores', max_words: 150 },
          { id: 'email_bf_ultimo', nombre: 'Último Día BF', momento: 'Viernes noche', objetivo: 'Urgencia BF', incluir: 'Termina mañana, mejores deals, link', excluir: 'Contenido nuevo', max_words: 120 },
          { id: 'email_cm_empieza', nombre: 'Cyber Monday Empieza', momento: 'Lunes 00:00', objetivo: 'Anunciar Cyber Monday', incluir: 'Ofertas extra, descuentos online, link', excluir: 'Repetir BF', max_words: 150 },
          { id: 'email_cm_flash', nombre: 'Flash Deals CM', momento: 'Lunes mediodía', objetivo: 'Ofertas flash', incluir: 'Deals por tiempo limitado, links', excluir: 'Ofertas permanentes', max_words: 130 },
          { id: 'email_cm_12h', nombre: 'Quedan 12h', momento: 'Lunes noche', objetivo: 'Urgencia CM', incluir: 'Horas restantes, mejores ofertas, link', excluir: 'Contenido nuevo', max_words: 110 },
          { id: 'email_cm_6h', nombre: '6 Horas', momento: '-6h cierre', objetivo: 'Presión final', incluir: 'Urgencia máxima, link', excluir: 'Explicaciones', max_words: 90 },
          { id: 'email_cm_1h', nombre: 'Última Hora', momento: '-1h cierre', objetivo: 'Último empujón', incluir: 'Cierra ya, link directo', excluir: 'Todo', max_words: 70 },
          { id: 'email_gracias', nombre: 'Gracias por Comprar', momento: 'Post BFCM', objetivo: 'Agradecer + fidelizar', incluir: 'Agradecimiento, próximas ofertas', excluir: 'Venta', max_words: 100 }
        ],
        whatsapp: [
          { id: 'wa_warmup', nombre: 'WA BF Viene', momento: '-7 días', objetivo: 'Anticipación', incluir: 'Fecha, mejores ofertas', excluir: 'Descuentos', max_chars: 180 },
          { id: 'wa_early', nombre: 'WA Early Access', momento: '-24h', objetivo: 'Acceso VIP', incluir: 'Link exclusivo, descuentos', excluir: 'Largo', max_chars: 200 },
          { id: 'wa_bf', nombre: 'WA BF Empieza', momento: 'Viernes', objetivo: 'Anunciar', incluir: 'Ofertas, link', excluir: 'Largo', max_chars: 180 },
          { id: 'wa_bf_ultimo', nombre: 'WA Último Día BF', momento: 'Viernes noche', objetivo: 'Urgencia', incluir: 'Termina, link', excluir: 'Contenido', max_chars: 160 },
          { id: 'wa_cm', nombre: 'WA Cyber Monday', momento: 'Lunes', objetivo: 'Anunciar CM', incluir: 'Ofertas extra, link', excluir: 'Repetir BF', max_chars: 180 },
          { id: 'wa_cm_12h', nombre: 'WA 12h', momento: 'Lunes noche', objetivo: 'Urgencia', incluir: 'Horas, link', excluir: 'Contenido', max_chars: 150 },
          { id: 'wa_cm_6h', nombre: 'WA 6h', momento: '-6h', objetivo: 'Presión final', incluir: 'Urgencia, link', excluir: 'Todo', max_chars: 140 },
          { id: 'wa_cierre', nombre: 'WA Cierre', momento: '-1h', objetivo: 'Final', incluir: 'Última hora, link', excluir: 'Todo', max_chars: 120 }
        ],
        piezas_requeridas: [
          { id: 'bf_1', nombre: 'Teaser — Black Friday Viene', tipo: 'captacion', orden: 1 },
          { id: 'bf_2', nombre: 'BF — Ofertas Disponibles', tipo: 'captacion', orden: 2 },
          { id: 'bf_3', nombre: 'BF — Mejor Oferta del Año', tipo: 'captacion', orden: 3 },
          { id: 'bf_4', nombre: 'CM — Cyber Monday Empieza', tipo: 'venta', orden: 4 },
          { id: 'bf_5', nombre: 'Urgencia — Últimas Horas', tipo: 'venta', orden: 5 }
        ]
      }
    ]
  },

  // ============================================
  // 📞 HIGH TICKET / CONSULTORÍA
  // ============================================
  {
    id: "high-ticket",
    label: "High Ticket",
    icon: "📞",
    color: "#8B5CF6",
    description: "Ventas de alto valor (€2K+) con proceso de cualificación y llamada.",
    separar_fases_creativos: false,
    variants: [
      {
        id: "aplicacion-llamada",
        label: "Aplicación + Llamada",
        description: "VSL/Caso de estudio → Formulario de aplicación → Llamada de cierre.",
        defaultAssets: {
          landings: ["VSL / Caso de Estudio", "Formulario Aplicación", "Confirmación + Agenda", "Thank You"],
          emails: 8,
          whatsapp: 5,
          adCopies: 5,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Caso de Estudio', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Resultado Cliente', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación — Perfil Ideal', tipo: 'captacion', orden: 3 },
          { id: 'cal_1', nombre: 'Cualificación — Pregunta Filtro', tipo: 'captacion', orden: 4 },
          { id: 'cal_2', nombre: 'Cualificación — Prueba Social', tipo: 'captacion', orden: 5 }
        ]
      },
      {
        id: "micro-webinar-llamada",
        label: "Micro-Webinar + Llamada",
        description: "Webinar corto (20-30 min) que precalienta → Agenda llamada directamente.",
        defaultAssets: {
          landings: ["Registro Micro-Webinar", "Sala Webinar", "Agendar Llamada", "Confirmación"],
          emails: 7,
          whatsapp: 4,
          adCopies: 4,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Promesa del Webinar', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Resultado Prometido', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación — Para Quién Es', tipo: 'captacion', orden: 3 },
          { id: 'ret_1', nombre: 'Retargeting — Recordatorio Webinar', tipo: 'captacion', orden: 4 }
        ]
      },
      {
        id: "challenge-high-ticket",
        label: "Challenge + Llamada",
        description: "Desafío de 5 días que demuestra expertise → Invitación a aplicar.",
        defaultAssets: {
          landings: ["Registro Challenge", "Día 1-5", "Aplicación", "Confirmación"],
          emails: 14,
          whatsapp: 10,
          adCopies: 8,
          adCreatives: 6
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — El Reto', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Transformación en X Días', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación — Testimonio del Challenge', tipo: 'captacion', orden: 3 },
          { id: 'ven_1', nombre: 'Aplicación — Invitación a Aplicar', tipo: 'venta', orden: 4 }
        ]
      }
    ]
  },

  // ============================================
  // 🏆 DESAFÍO / CHALLENGE
  // ============================================
  {
    id: "desafio",
    label: "Desafío",
    icon: "🏆",
    color: "#F97316",
    description: "Retos de transformación que generan resultados rápidos y comunidad.",
    separar_fases_creativos: true,
    variants: [
      {
        id: "reto-5-dias",
        label: "Reto 5 Días",
        description: "Challenge intensivo de una semana laboral. Acción diaria + comunidad.",
        defaultAssets: {
          landings: ["Registro Reto", "Hub del Reto", "Día 1", "Día 2", "Día 3", "Día 4", "Día 5 + Oferta", "Ventas"],
          emails: 12,
          whatsapp: 8,
          adCopies: 6,
          adCreatives: 6
        },
        adCreatives: [
          // FASE CAPTACIÓN (3)
          { id: 'cap_video_reto', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — El Reto que Cambiará Todo' },
          { id: 'cap_imagen_transformacion', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Antes y Después' },
          { id: 'cap_reel_dia1', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Preview Día 1' },
          // FASE VENTA (3)
          { id: 'ven_video_oferta', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Oferta Día 5' },
          { id: 'ven_imagen_resultado', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Resultados Participantes' },
          { id: 'ven_story_cierre', tipo: 'venta', formato: 'story', nombre: 'Story — Últimas Horas' }
        ]
      },
      {
        id: "reto-7-dias",
        label: "Reto 7 Días",
        description: "Una semana completa de transformación. Más profundidad y conexión.",
        defaultAssets: {
          landings: ["Registro", "Hub", "Día 1-7", "Página de Ventas", "Checkout"],
          emails: 16,
          whatsapp: 10,
          adCopies: 8,
          adCreatives: 8
        },
        adCreatives: [
          // FASE CAPTACIÓN (4)
          { id: 'cap_video_reto', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — El Reto de 7 Días' },
          { id: 'cap_imagen_transformacion', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — La Transformación' },
          { id: 'cap_reel_preview', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Preview del Reto' },
          { id: 'cap_testimonio', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — Participante Anterior' },
          // FASE VENTA (4)
          { id: 'ven_video_oferta', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Oferta Especial' },
          { id: 'ven_imagen_resultado', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Resultados del Reto' },
          { id: 'ven_imagen_urgencia', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Plazas Limitadas' },
          { id: 'ven_story_cierre', tipo: 'venta', formato: 'story', nombre: 'Story — Cierre de Inscripciones' }
        ]
      },
      {
        id: "reto-21-dias",
        label: "Reto 21 Días",
        description: "Transformación de hábitos. 3 semanas para resultados sostenibles.",
        defaultAssets: {
          landings: ["Registro", "Hub", "Resumen Semana 1", "Resumen Semana 2", "Resumen Semana 3", "Ventas"],
          emails: 24,
          whatsapp: 12,
          adCopies: 10,
          adCreatives: 8
        },
        adCreatives: [
          // FASE CAPTACIÓN (4)
          { id: 'cap_video_transformacion', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — Transformación 21 Días' },
          { id: 'cap_imagen_habitos', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — El Hábito que lo Cambia Todo' },
          { id: 'cap_reel_semana1', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Preview Semana 1' },
          { id: 'cap_testimonio', tipo: 'captacion', formato: 'video', nombre: 'Vídeo Testimonio — 21 Días Después' },
          // FASE VENTA (3)
          { id: 'ven_video_oferta', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Oferta Final' },
          { id: 'ven_imagen_comunidad', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Únete a la Comunidad' },
          { id: 'ven_story_cierre', tipo: 'venta', formato: 'story', nombre: 'Story — Cierre' }
        ]
      }
    ]
  },

  // ============================================
  // 💎 MEMBRESÍA / COMUNIDAD
  // ============================================
  {
    id: "membresia",
    label: "Membresía",
    icon: "💎",
    color: "#06B6D4",
    description: "Suscripciones y comunidades de pago recurrente.",
    separar_fases_creativos: true,
    variants: [
      {
        id: "prueba-gratuita",
        label: "Prueba Gratuita 7 Días",
        description: "Trial gratis → Secuencia de onboarding → Conversión a pago.",
        defaultAssets: {
          landings: ["Landing Trial", "Onboarding", "Página de Upgrade"],
          emails: 8,
          whatsapp: 4,
          adCopies: 4,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Prueba Gratis 7 Días', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Qué Incluye la Membresía', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación — Testimonio Miembro', tipo: 'captacion', orden: 3 },
          { id: 'ret_1', nombre: 'Retargeting — No Pierdas el Trial', tipo: 'captacion', orden: 4 }
        ]
      },
      {
        id: "waitlist-apertura",
        label: "Waitlist + Apertura",
        description: "Lista de espera exclusiva → Acceso anticipado → Apertura pública.",
        defaultAssets: {
          landings: ["Waitlist", "Confirmación", "Acceso Anticipado", "Página de Ventas"],
          emails: 10,
          whatsapp: 6,
          adCopies: 5,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Lista de Espera Exclusiva', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Beneficios Miembro', tipo: 'captacion', orden: 2 },
          { id: 'ven_1', nombre: 'Apertura — Ya Tienes Acceso', tipo: 'venta', orden: 3 },
          { id: 'ven_2', nombre: 'Urgencia — Plazas Limitadas', tipo: 'venta', orden: 4 }
        ]
      },
      {
        id: "founding-members",
        label: "Founding Members",
        description: "Precio especial para primeros miembros. Crea exclusividad y urgencia.",
        defaultAssets: {
          landings: ["Landing Founders", "Página de Membresía", "Checkout Especial", "Bienvenida"],
          emails: 8,
          whatsapp: 5,
          adCopies: 5,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Precio Fundador Exclusivo', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Esto No Volverá', tipo: 'captacion', orden: 2 },
          { id: 'ven_1', nombre: 'Venta — Últimos Founding Members', tipo: 'venta', orden: 3 },
          { id: 'ven_2', nombre: 'Urgencia — Se Acaba el Precio Especial', tipo: 'venta', orden: 4 }
        ]
      }
    ]
  },

  // ============================================
  // 💻 SAAS
  // ============================================
  {
    id: "saas",
    label: "SaaS",
    icon: "💻",
    color: "#3B82F6",
    description: "Estrategias para software como servicio con onboarding técnico.",
    separar_fases_creativos: true,
    variants: [
      {
        id: "saas-free-trial",
        label: "Free Trial 14 Días",
        description: "Captación para prueba gratuita con secuencia de onboarding técnico y urgencia de upgrade.",
        defaultAssets: {
          landings: ["Homepage", "Registro Trial", "Dashboard Onboarding", "Pricing"],
          emails: 10,
          whatsapp: 3,
          adCopies: 6,
          adCreatives: 6
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Prueba Gratis 14 Días', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Problema que Resuelve', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación — Demo del Software', tipo: 'captacion', orden: 3 },
          { id: 'ret_1', nombre: 'Retargeting — Aún Puedes Probarlo', tipo: 'captacion', orden: 4 }
        ]
      },
      {
        id: "saas-freemium",
        label: "Freemium → Upgrade",
        description: "Plan gratis con límites → Educación sobre features Pro → Conversión.",
        defaultAssets: {
          landings: ["Homepage", "Features Pro", "Pricing", "Upgrade"],
          emails: 8,
          whatsapp: 2,
          adCopies: 5,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Empieza Gratis', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Funcionalidades Pro', tipo: 'captacion', orden: 2 },
          { id: 'upsell_1', nombre: 'Upgrade — Desbloquea el Pro', tipo: 'venta', orden: 3 }
        ]
      },
      {
        id: "saas-demo",
        label: "Demo + Onboarding",
        description: "Demostración guiada para enterprise. Proceso consultivo.",
        defaultAssets: {
          landings: ["Homepage", "Agendar Demo", "Confirmación", "Propuesta"],
          emails: 8,
          whatsapp: 4,
          adCopies: 4,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Solicita tu Demo', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Caso de Éxito Cliente', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Captación — ROI del Software', tipo: 'captacion', orden: 3 }
        ]
      },
      {
        id: "saas-evento",
        label: "Evento en Directo",
        description: "Webinar de producto con demo en vivo y oferta especial.",
        defaultAssets: {
          landings: ["Registro Evento", "Sala", "Replay", "Oferta Especial"],
          emails: 8,
          whatsapp: 5,
          adCopies: 5,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Evento de Producto', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Captación — Demo en Vivo', tipo: 'captacion', orden: 2 },
          { id: 'ven_1', nombre: 'Oferta — Especial Asistentes', tipo: 'venta', orden: 3 }
        ]
      }
    ]
  },

  // ============================================
  // 🎯 ORGÁNICO / CONTENIDO
  // ============================================
  {
    id: "organico",
    label: "Orgánico",
    icon: "🎯",
    color: "#10B981",
    description: "Estrategias de monetización de contenido y tráfico orgánico.",
    separar_fases_creativos: false,
    variants: [
      {
        id: "lead-magnet-newsletter",
        label: "Lead Magnet + Newsletter",
        description: "Recurso gratuito → Secuencia de bienvenida → Monetización gradual.",
        defaultAssets: {
          landings: ["Descarga Lead Magnet", "Thank You + Oferta"],
          emails: 8,
          whatsapp: 2,
          adCopies: 3,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Lead Magnet — Descarga Gratis', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Newsletter — Lo que Aprenderás', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Contenido — Valor Gratuito', tipo: 'captacion', orden: 3 }
        ]
      },
      {
        id: "embudos-dm",
        label: "Embudos DM / ManyChat",
        description: "Automatización de DMs en Instagram/Facebook con ManyChat o similar.",
        defaultAssets: {
          landings: ["Mini-Landing Link en Bio", "Página de Oferta"],
          emails: 5,
          whatsapp: 6,
          adCopies: 4,
          adCreatives: 6
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Contenido — Gancho para DM', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Reel — Comenta para Recibir', tipo: 'captacion', orden: 2 }
        ]
      },
      {
        id: "lanzamiento-semilla",
        label: "Lanzamiento Semilla",
        description: "Validar oferta con audiencia existente antes de lanzamiento grande.",
        defaultAssets: {
          landings: ["Página de Interés", "Formulario Feedback", "Oferta Early Bird"],
          emails: 6,
          whatsapp: 4,
          adCopies: 3,
          adCreatives: 3
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Validación — Pregunta a tu Audiencia', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Early Bird — Precio Especial', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Social Proof — Primeros Inscritos', tipo: 'venta', orden: 3 }
        ]
      },
      {
        id: "reactivacion-audiencia",
        label: "Reactivación de Audiencia",
        description: "Campañas para re-enganchar suscriptores inactivos con contenido nuevo.",
        defaultAssets: {
          landings: ["Contenido Exclusivo", "Encuesta", "Oferta Especial"],
          emails: 6,
          whatsapp: 3,
          adCopies: 3,
          adCreatives: 3
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Reactivación — Hola de Nuevo', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Contenido — Novedad Exclusiva', tipo: 'captacion', orden: 2 }
        ]
      }
    ]
  },

  // ============================================
  // 📍 LOCAL / NEGOCIOS CON CITAS
  // ============================================
  {
    id: "local",
    label: "Local",
    icon: "📍",
    color: "#F472B6",
    description: "Estrategias para negocios locales, clínicas, gimnasios, servicios.",
    separar_fases_creativos: false,
    variants: [
      {
        id: "lead-gen-oferta",
        label: "Lead Gen + Oferta Irresistible",
        description: "Oferta gancho (ej: primera sesión gratis) → Captación → Seguimiento.",
        defaultAssets: {
          landings: ["Landing Oferta Local", "Formulario Cita", "Confirmación"],
          emails: 5,
          whatsapp: 5,
          adCopies: 5,
          adCreatives: 6
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Oferta Local — Primera Sesión', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Negocio — Quiénes Somos', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Testimonio — Cliente Local', tipo: 'captacion', orden: 3 },
          { id: 'ret_1', nombre: 'Retargeting — Aún Puedes Reservar', tipo: 'venta', orden: 4 }
        ]
      },
      {
        id: "reactivacion-db",
        label: "Reactivación Base de Datos",
        description: "Campaña para clientes antiguos con oferta especial de regreso.",
        defaultAssets: {
          landings: ["Landing Clientes Antiguos", "Oferta Regreso"],
          emails: 4,
          whatsapp: 4,
          adCopies: 3,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Reactivación — Te Echamos de Menos', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Oferta — Solo para Clientes Antiguos', tipo: 'captacion', orden: 2 }
        ]
      },
      {
        id: "google-local",
        label: "Google Ads Local",
        description: "Captación de búsquedas locales + Landing optimizada para conversión.",
        defaultAssets: {
          landings: ["Landing Google Ads", "Página de Servicios", "Reserva"],
          emails: 4,
          whatsapp: 3,
          adCopies: 6,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Google — Solución Inmediata', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Google — Cerca de Ti', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Google — Reseñas y Confianza', tipo: 'captacion', orden: 3 }
        ]
      }
    ]
  },

  // ============================================
  // 🤖 AGENTES IA
  // ============================================
  {
    id: "agentes-ia",
    label: "Agentes IA",
    icon: "🤖",
    color: "#A855F7",
    description: "Embudos potenciados por agentes de IA para automatización avanzada.",
    separar_fases_creativos: false,
    variants: [
      {
        id: "ia-texto-whatsapp",
        label: "Embudo IA Texto/WhatsApp",
        description: "Agente conversacional por WhatsApp que cualifica y agenda automáticamente.",
        defaultAssets: {
          landings: ["Landing Principal", "Chat IA", "Agenda Automática"],
          emails: 4,
          whatsapp: 8,
          adCopies: 4,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — El Agente IA que Necesitas', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Demo — Así Funciona en Vivo', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Resultado — Ahorra X Horas/Semana', tipo: 'captacion', orden: 3 }
        ]
      },
      {
        id: "ia-voz-llamadas",
        label: "Embudo IA Voz/Llamadas",
        description: "Agente de voz IA que hace llamadas de cualificación y seguimiento.",
        defaultAssets: {
          landings: ["Landing Captura", "Confirmación Llamada", "Propuesta"],
          emails: 5,
          whatsapp: 4,
          adCopies: 4,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Asistente de Voz IA', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Demo — Escucha una Llamada Real', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Resultado — Llamadas en Piloto Automático', tipo: 'captacion', orden: 3 }
        ]
      },
      {
        id: "ia-chatbot-web",
        label: "Chatbot IA en Web",
        description: "Chatbot inteligente en landing que cualifica y convierte visitantes.",
        defaultAssets: {
          landings: ["Landing con Chatbot", "Página de Oferta", "Checkout"],
          emails: 5,
          whatsapp: 3,
          adCopies: 4,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Chatbot que Vende por Ti', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Demo — Prueba el Chat en Vivo', tipo: 'captacion', orden: 2 },
          { id: 'cap_3', nombre: 'Resultado — Conversiones 24/7', tipo: 'captacion', orden: 3 }
        ]
      }
    ]
  },

  // ============================================
  // ☄️ EMBUDOS WHATSAPP
  // ============================================
  {
    id: "embudos-wa",
    label: "WhatsApp",
    icon: "☄️",
    color: "#25D366",
    description: "Estrategias centradas en WhatsApp y grupos de Telegram.",
    separar_fases_creativos: false,
    variants: [
      {
        id: "meteorito-grupos",
        label: "Lanzamiento Meteorito",
        description: "Grupos de WhatsApp/Telegram con contenido intensivo y oferta relámpago.",
        defaultAssets: {
          landings: ["Registro al Grupo", "Página de Oferta"],
          emails: 4,
          whatsapp: 12,
          adCopies: 4,
          adCreatives: 5
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Únete al Grupo', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Contenido — Preview del Grupo', tipo: 'captacion', orden: 2 },
          { id: 'ven_1', nombre: 'Oferta — Exclusivo para el Grupo', tipo: 'venta', orden: 3 }
        ]
      },
      {
        id: "micro-reto-3-dias",
        label: "Micro-Reto 3 Días WA",
        description: "Reto express por WhatsApp. 3 días de contenido + oferta el día 4.",
        defaultAssets: {
          landings: ["Registro Micro-Reto", "Página de Ventas"],
          emails: 3,
          whatsapp: 10,
          adCopies: 4,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — 3 Días de Transformación', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Contenido — Lo que Vas a Aprender', tipo: 'captacion', orden: 2 },
          { id: 'ven_1', nombre: 'Oferta — Día 4 Especial', tipo: 'venta', orden: 3 }
        ]
      },
      {
        id: "lista-broadcast",
        label: "Lista de Broadcast",
        description: "Captación a lista de difusión con secuencia de nurturing y venta.",
        defaultAssets: {
          landings: ["Opt-in WhatsApp", "Página de Oferta"],
          emails: 2,
          whatsapp: 8,
          adCopies: 3,
          adCreatives: 4
        },
        piezas_requeridas: [
          { id: 'cap_1', nombre: 'Captación — Únete a la Lista VIP', tipo: 'captacion', orden: 1 },
          { id: 'cap_2', nombre: 'Contenido — Beneficios Exclusivos', tipo: 'captacion', orden: 2 },
          { id: 'ven_1', nombre: 'Oferta — Solo para la Lista', tipo: 'venta', orden: 3 }
        ]
      }
    ]
  },

  // ============================================
  // 🎁 VIRAL / SORTEOS
  // ============================================
  {
    id: "viral",
    label: "Viral",
    icon: "🎁",
    color: "#FBBF24",
    description: "Campañas virales, sorteos y gamificación para crecimiento explosivo.",
    separar_fases_creativos: true,
    variants: [
      {
        id: "sorteo-giveaway",
        label: "Sorteo / Giveaway",
        description: "Sorteo viral con mecánica de referidos para multiplicar participantes.",
        defaultAssets: {
          landings: ["Landing Sorteo", "Página de Referidos", "Ganadores"],
          emails: 6,
          whatsapp: 4,
          adCopies: 5,
          adCreatives: 8
        },
        adCreatives: [
          // FASE CAPTACIÓN (4)
          { id: 'cap_sorteo_anuncio', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Anuncio del Sorteo' },
          { id: 'cap_sorteo_premio', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — El Premio' },
          { id: 'cap_sorteo_como', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Cómo Participar' },
          { id: 'cap_sorteo_urgencia', tipo: 'captacion', formato: 'story', nombre: 'Story — Quedan X Días' },
          // FASE VENTA (2)
          { id: 'ven_sorteo_ganador', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Anuncio Ganador' },
          { id: 'ven_sorteo_oferta', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Oferta Post-Sorteo' }
        ]
      },
      {
        id: "concurso-ugc",
        label: "Concurso UGC",
        description: "Concurso de contenido generado por usuarios. Engagement + prueba social.",
        defaultAssets: {
          landings: ["Landing Concurso", "Galería Participantes", "Votación", "Ganadores"],
          emails: 6,
          whatsapp: 4,
          adCopies: 4,
          adCreatives: 6
        },
        adCreatives: [
          // FASE CAPTACIÓN (3)
          { id: 'cap_concurso_anuncio', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Anuncio del Concurso' },
          { id: 'cap_concurso_como', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Cómo Participar' },
          { id: 'cap_concurso_premio', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — Los Premios' },
          // FASE VENTA (3)
          { id: 'ven_concurso_galeria', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Mejores Participaciones' },
          { id: 'ven_concurso_vota', tipo: 'venta', formato: 'story', nombre: 'Story — Vota por tu Favorito' },
          { id: 'ven_concurso_ganador', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Anuncio Ganador' }
        ]
      },
      {
        id: "referral-program",
        label: "Programa de Referidos",
        description: "Sistema de recompensas por referir amigos. Crecimiento orgánico.",
        defaultAssets: {
          landings: ["Landing Referidos", "Dashboard de Puntos", "Premios"],
          emails: 5,
          whatsapp: 3,
          adCopies: 4,
          adCreatives: 4
        },
        adCreatives: [
          // FASE CAPTACIÓN (2)
          { id: 'cap_referral_invita', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Invita y Gana' },
          { id: 'cap_referral_premios', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — Los Premios Disponibles' },
          // FASE VENTA (2)
          { id: 'ven_referral_top', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Top Referidores' },
          { id: 'ven_referral_urgencia', tipo: 'venta', formato: 'story', nombre: 'Story — Últimos Días del Programa' }
        ]
      }
    ]
  },

  // ============================================
  // 🎫 EVENTOS PRESENCIALES
  // ============================================
  {
    id: "eventos",
    label: "Eventos",
    icon: "🎫",
    color: "#DC2626",
    description: "Eventos presenciales: talleres, conferencias, retiros VIP.",
    separar_fases_creativos: true,
    variants: [
      {
        id: "taller-workshop",
        label: "Taller / Workshop Local",
        description: "Evento presencial de medio día o día completo. Oferta al final.",
        defaultAssets: {
          landings: ["Landing Evento", "Registro", "Confirmación + Logística", "Página de Ventas"],
          emails: 8,
          whatsapp: 6,
          adCopies: 5,
          adCreatives: 6
        },
        adCreatives: [
          // FASE CAPTACIÓN (3)
          { id: 'cap_evento_anuncio', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Anuncio del Evento' },
          { id: 'cap_evento_ponente', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — El Ponente' },
          { id: 'cap_evento_preview', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Preview del Taller' },
          // FASE VENTA (3)
          { id: 'ven_evento_plazas', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Plazas Limitadas' },
          { id: 'ven_evento_urgencia', tipo: 'venta', formato: 'story', nombre: 'Story — Últimos Días' },
          { id: 'ven_evento_testimonios', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Ediciones Anteriores' }
        ]
      },
      {
        id: "conferencia-congreso",
        label: "Conferencia / Congreso",
        description: "Gran evento con múltiples speakers. Early bird + VIP + General.",
        defaultAssets: {
          landings: ["Landing Principal", "Speakers", "Agenda", "Tickets", "Patrocinadores"],
          emails: 14,
          whatsapp: 8,
          adCopies: 10,
          adCreatives: 12
        },
        adCreatives: [
          // FASE CAPTACIÓN (6)
          { id: 'cap_conf_anuncio', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Anuncio del Congreso' },
          { id: 'cap_conf_speakers', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — Los Speakers' },
          { id: 'cap_conf_agenda', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Agenda Completa' },
          { id: 'cap_conf_preview', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Preview del Evento' },
          { id: 'cap_conf_early', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Early Bird Disponible' },
          { id: 'cap_conf_testimonio', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — Ediciones Anteriores' },
          // FASE VENTA (6)
          { id: 'ven_conf_vip', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Entradas VIP' },
          { id: 'ven_conf_plazas', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Plazas Agotándose' },
          { id: 'ven_conf_urgencia', tipo: 'venta', formato: 'story', nombre: 'Story — Últimas Entradas' },
          { id: 'ven_conf_networking', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Networking Exclusivo' },
          { id: 'ven_conf_early_fin', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Early Bird Termina' },
          { id: 'ven_conf_cierre', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre de Inscripciones' }
        ]
      },
      {
        id: "retiro-vip",
        label: "Retiro VIP / Mastermind",
        description: "Experiencia exclusiva de alto ticket. Proceso de selección incluido.",
        defaultAssets: {
          landings: ["Landing Retiro", "Aplicación", "Experiencia", "Testimonios"],
          emails: 10,
          whatsapp: 6,
          adCopies: 5,
          adCreatives: 6
        },
        adCreatives: [
          // FASE CAPTACIÓN (3)
          { id: 'cap_retiro_experiencia', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — La Experiencia' },
          { id: 'cap_retiro_lugar', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — El Lugar' },
          { id: 'cap_retiro_para_quien', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Para Quién Es' },
          // FASE VENTA (3)
          { id: 'ven_retiro_plazas', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Solo X Plazas' },
          { id: 'ven_retiro_testimonio', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Testimonios Anteriores' },
          { id: 'ven_retiro_aplica', tipo: 'venta', formato: 'story', nombre: 'Story — Aplica Ahora' }
        ]
      },
      {
        id: "evento-hibrido",
        label: "Evento Híbrido",
        description: "Presencial + Online simultáneo. Maximiza alcance y ticket promedio.",
        defaultAssets: {
          landings: ["Landing Principal", "Ticket Presencial", "Ticket Online", "Agenda"],
          emails: 12,
          whatsapp: 7,
          adCopies: 8,
          adCreatives: 8
        },
        adCreatives: [
          // FASE CAPTACIÓN (4)
          { id: 'cap_hibrido_anuncio', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Evento Presencial + Online' },
          { id: 'cap_hibrido_preview', tipo: 'captacion', formato: 'video', nombre: 'Vídeo — Preview del Evento' },
          { id: 'cap_hibrido_opciones', tipo: 'captacion', formato: 'imagen', nombre: 'Imagen — Elige tu Modalidad' },
          { id: 'cap_hibrido_speakers', tipo: 'captacion', formato: 'reel', nombre: 'Reel — Los Speakers' },
          // FASE VENTA (4)
          { id: 'ven_hibrido_presencial', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Ven en Persona' },
          { id: 'ven_hibrido_online', tipo: 'venta', formato: 'imagen', nombre: 'Imagen — Únete Online' },
          { id: 'ven_hibrido_urgencia', tipo: 'venta', formato: 'story', nombre: 'Story — Plazas Limitadas' },
          { id: 'ven_hibrido_cierre', tipo: 'venta', formato: 'video', nombre: 'Vídeo — Cierre de Inscripciones' }
        ]
      }
    ]
  }
];

/**
 * Helper functions
 */

export const getStrategyById = (id) => {
  return FUNNEL_STRATEGIES.find(s => s.id === id);
};

export const getVariantById = (strategyId, variantId) => {
  const strategy = getStrategyById(strategyId);
  return strategy?.variants.find(v => v.id === variantId);
};

export const getDefaultAssets = (strategyId, variantId) => {
  const variant = getVariantById(strategyId, variantId);
  return variant?.defaultAssets || null;
};

/**
 * Get piezas_requeridas for a variant.
 * If variant doesn't have piezas_requeridas, generate default based on adCopies count.
 */
export const getPiezasRequeridas = (strategyId, variantId) => {
  const variant = getVariantById(strategyId, variantId);
  
  if (!variant) return [];
  
  // If variant has explicit piezas_requeridas, return them
  if (variant.piezas_requeridas && variant.piezas_requeridas.length > 0) {
    return variant.piezas_requeridas;
  }
  
  // Otherwise, generate default piezas based on adCopies count
  const totalPiezas = variant.defaultAssets?.adCopies || 5;
  const captacionCount = Math.ceil(totalPiezas * 0.6); // 60% captación
  const ventaCount = totalPiezas - captacionCount; // 40% venta
  
  const piezas = [];
  
  // Add captación pieces
  for (let i = 1; i <= captacionCount; i++) {
    piezas.push({
      id: `cap_${i}`,
      nombre: `Captación ${i} - ${i === 1 ? 'Dolor Principal' : i === 2 ? 'Identificación' : 'Curiosidad'}`,
      tipo: 'captacion',
      orden: i
    });
  }
  
  // Add venta pieces
  for (let i = 1; i <= ventaCount; i++) {
    piezas.push({
      id: `venta_${i}`,
      nombre: `Venta ${i} - ${i === ventaCount ? 'Cierre Final' : 'Oferta'}`,
      tipo: 'venta',
      orden: captacionCount + i
    });
  }
  
  return piezas;
};

/**
 * Calculate totals for display
 */
export const calculateAssetTotals = (assets) => {
  if (!assets) return null;
  
  const { landings, emails, whatsapp, adCopies, adCreatives, cartHours } = assets;
  
  return {
    landingsCount: landings?.length || 0,
    landingsList: landings || [],
    emailsCount: emails || 0,
    whatsappCount: whatsapp || 0,
    adCopiesCount: adCopies || 0,
    adCreativesCount: adCreatives || 0,
    cartHours: cartHours || null,
    totalPieces: (landings?.length || 0) + (emails || 0) + (whatsapp || 0) + (adCopies || 0) + (adCreatives || 0)
  };
};

/**
 * Asset limits for customization
 */
export const ASSET_LIMITS = {
  emails: { min: 1, max: 25 },
  whatsapp: { min: 1, max: 15 },
  adCopies: { min: 1, max: 15 },
  adCreatives: { min: 1, max: 15 },
  cartHours: { min: 12, max: 168, step: 12 }
};

export default FUNNEL_STRATEGIES;
